import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import { AuthContext } from "../../../../../shared/context/auth-context";
import { dadosImpressao } from "../../../../../shared/util/dadosImpressao";
import BadgeUnidade from "../../../../../shared/components/badgeUnidade/BadgeUnidade";
import SeloSoConsulta from "../../../../../shared/components/badgeUnidade/SeloSoConsulta";
import {
  podeAlterarRegisto,
  podeMexerNoDocumento,
  motivoBloqueioDocumento,
} from "../../../../../shared/util/unidadeRegisto";
import { useContingenciaEfatura } from "../../../../../shared/hooks/contingencia-efatura-hook";
//MUI
import { DataGrid } from "@mui/x-data-grid";
import dataGridData from "./components/datagridData";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
/////////////////////////////////////////////////////
import ModalReceber from "./components/ModalReceber";
import ModalCorrigirCaixa, {
  podeCorrigirCaixa,
} from "../../../../../shared/components/modalCorrigirCaixa/ModalCorrigirCaixa";
import ModalVerReceita from "./components/ModalVerPagamento/ModalVerReceita";
import ModalMotivoCancelamento from "./components/ModalMotivoCancelamento/ModalMotivoCancelamento";
import "./Debitos.scss";
import { useLoading } from "../../../../../shared/context/LoadingContext";
//Antd
import { Popover, Space } from "antd";
import { Popconfirm } from "antd";
import toast from "react-hot-toast";
import { ClinicaContext } from "../../../../../shared/context/clinica-context";
import ModalEditarDesconto from "./components/ModalEditarDesconto/ModalEditarDesconto";
import ModalExtrato from "./components/ModalExtrato/ModalExtrato";
import ModalVerEntrada from "../../../../financeiro/receitas/components/modalEntrada/ModalVerEntrada";
//Mui button dropdown
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ModalMotivoCancelamentoPendencias from "./components/ModalMotivoCancelamentoPendencias/ModalMotivoCancelamentoPendencias";
import ModalEditarEntradaDebito from "./components/modalEntradaDebito/ModalEditarEntradaDebito";
import ModalEntradaDebito from "./components/modalEntradaDebito/ModalEntradaDebito";

import CancelIcon from "@mui/icons-material/Cancel";
import HistoryIcon from "@mui/icons-material/History";
import DiscountIcon from "@mui/icons-material/Discount";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

import ModalInfo from "../../../../../shared/components/UIElements/ModalInfo";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import Badge from "@mui/material/Badge";
import CommentIcon from "@mui/icons-material/Comment";
import TextField from "@mui/material/TextField";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Chip,
  Alert,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ModalReceberEntradaDebito from "./components/modalEntradaDebito/ModalReceberEntradaDebito";
import ModalEditarMajoracao from "./components/ModalEditarMajoracao/ModalEditarMajoracao";
import ModalVerOrcamento from "../OrcamentosComponent/components/ModalVerOrcamento/ModalVerOrcamento";

import ModalNotasDebitos from "./components/ModalNotasDebitos/ModalNotasDebitos";

const MOTIVOS_CONTINGENCIA = [
  { codigo: 1, label: "Indisponibilidade do serviço de autorização de DFEs" },
  { codigo: 2, label: "Falta de energia elétrica no estabelecimento" },
  { codigo: 3, label: "Indisponibilidade do sistema do contribuinte" },
  { codigo: 4, label: "Indisponibilidade de conexão Internet" },
  { codigo: 5, label: "Indisponibilidade do serviço de TimeStamp" },
  { codigo: 0, label: "Outro (especificar)" },
];

/* ─── O RECIBO INTERNO SEM RESTRIÇÕES, NUMA CLÍNICA SÓ ──────────────────────
 *
 * Por omissão o recibo interno só se emite de um pagamento em DINHEIRO e, nas
 * parcelas, de um orçamento Particular ou Misto. A HEALTHTECH CV LDA («odontoUP»)
 * pediu para o poder emitir de qualquer recebimento, e a mudança é só dela —
 * as outras clínicas não a pediram e não devem apanhá-la de lado.
 *
 * O id vive aqui com nome e com esta nota de propósito. O hábito da casa é
 * escrevê-lo solto no meio do JSX (ver `Financeiro.js` e os PDFs dos
 * orçamentos), e daqui a um ano ninguém sabe de quem é aquele número.
 *
 * O que isto NÃO levanta: emitir recibo interno por cima de uma FRE ou TVE já
 * emitida com sucesso. Isso daria ao cliente dois comprovativos do mesmo
 * pagamento, um deles sem valor fiscal, e não é uma restrição de conveniência.
 */
const CLINICA_RECIBO_SEM_RESTRICOES = "63230ebecb8db95d70cb3456";

function Debitos({
  clienteId,
  sendRequest,
  nomeCliente,
  dadosFatura,
  clienteData,
  dadosRecibo,
  changeClienteNotasData,
  showRce,
  showExtrato,
}) {
  const { startLoading, stopLoading } = useLoading();

  const [totalRecebido, setTotalRecebido] = useState(0);
  const [totalReceber, setTotalReceber] = useState(0);
  const [rows, setRows] = useState([]);
  const [contaCorrente, setContaCorrente] = useState();
  const [entradas, setEntradas] = useState();
  const [valor, setValor] = useState(0);
  const [idParcela, setIdParcela] = useState();
  const [descricaoParcela, setDescricaoParcela] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState();
  const [mostrarExtrato, setMostrarExtrato] = useState(false);
  /* Contador para voltar a pedir a conta corrente. Quem corrige a caixa de uma
     parcela precisa de ver o valor novo sem sair da ficha. */
  const [recarga, setRecarga] = useState(0);
  /* `{ tipo, id }` do registo a editar (caixa, descrição e observação). */
  const [corrigirCaixa, setCorrigirCaixa] = useState(null);
  const [mostrarRecebidos, setMostrarRecebidos] = useState(true);
  const [dadosClinica, setDadosClinica] = useState();
  const [dadosModalMotivoCancelamento, setDadosModalMotivoCancelamento] =
    useState({
      open: false,
    });

  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);

  /* Ver a nota em `CLINICA_RECIBO_SEM_RESTRICOES`, no topo do ficheiro. */
  const reciboSemRestricoes =
    clinica?.clinica?._id === CLINICA_RECIBO_SEM_RESTRICOES;
  const { modoContingenciaAtivo } = useContingenciaEfatura();

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [documentoPendente, setDocumentoPendente] = useState(null);
  const [entradaPendente, setEntradaPendente] = useState(null);

  const [modalProps, setModalProps] = useState({
    show: false,
    icon: "",
    title: "",
    message: "",
    form: false,
  });

  //Emissão de contingência
  const [dialogContingenciaOpen, setDialogContingenciaOpen] = useState(false);
  const [dadosContingenciaPendente, setDadosContingenciaPendente] =
    useState(null);
  const [motivoContingenciaSelecionado, setMotivoContingenciaSelecionado] =
    useState(1);
  const [descricaoContingenciaOutro, setDescricaoContingenciaOutro] =
    useState("");
  // Para NCEs em contingência
  const [dadosCancelamentoPendente, setDadosCancelamentoPendente] =
    useState(null);
  const [modalNotasOpen, setModalNotasOpen] = useState(false);

  // Handlers para o diálogo
  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
    setDocumentoPendente(null);
    setEntradaPendente(null);
  };

  const handleConfirmDialogConfirm = () => {
    setConfirmDialogOpen(false);

    // Executar a operação pendente
    if (documentoPendente) {
      emitirDocumentoFiscal(
        documentoPendente.tipoDocumento,
        documentoPendente.parcela,
      );
      setDocumentoPendente(null);
    } else if (entradaPendente) {
      emitirDocEletronicoEntradas(
        entradaPendente.entrada,
        entradaPendente.idEntrada,
        entradaPendente.tipoDocumento,
        entradaPendente.operacao,
      );
      setEntradaPendente(null);
    }
  };
  // Método para verificar e emitir documento
  const verificarEEmitirDocumento = (tipoDocumento, parcela) => {
    // Verificar se o nome e nomeFiscal são diferentes
    if (contaCorrente.cliente?.nome !== contaCorrente.cliente?.nomeFiscal) {
      // Guardar a operação pendente e mostrar o diálogo
      setDocumentoPendente({ tipoDocumento, parcela });
      setConfirmDialogOpen(true);
    } else {
      // Se não houver diferença, prosseguir normalmente
      emitirDocumentoFiscal(tipoDocumento, parcela);
    }
  };

  // Método para verificar e emitir documento para entradas
  const verificarEEmitirDocumentoEntrada = (
    entrada,
    idEntrada,
    tipoDocumento,
    operacao,
  ) => {
    // Verificar se o nome e nomeFiscal são diferentes
    if (clienteData?.nome !== clienteData?.nomeFiscal) {
      // Guardar a operação pendente e mostrar o diálogo
      setEntradaPendente({ entrada, idEntrada, tipoDocumento, operacao });
      setConfirmDialogOpen(true);
    } else {
      // Se não houver diferença, prosseguir normalmente
      emitirDocEletronicoEntradas(entrada, idEntrada, tipoDocumento, operacao);
    }
  };

  const handleModalCancel = () => {
    setModalProps((currentModalProps) => {
      return { ...currentModalProps, show: false };
    });
  };

  const handleConfirmRestaurarPendencia = async (conta) => {
    setModalProps({
      show: true,
      icon: "info",
      title: `Restaurar Pendências!`,
      message: `Tem a certeza que pretende restaurar as pendências da conta?`,
      form: true,
      onCancel: handleModalCancel,
      onConfirm: handleRestaurarPendencias.bind(null, conta),
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const [contaCorrenteResponse, entradasResponse, clinicaResponse] =
          await Promise.all([
            sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/orcamento/cliente/${clienteId}`,
              "GET",
              null,
              { Authorization: "Bearer " + auth.token },
            ),
            auth.perm.includes("r-ent")
              ? sendRequest(
                  `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/cliente/${clienteId}`,
                  "GET",
                  null,
                  { Authorization: "Bearer " + auth.token },
                )
              : Promise.resolve({ entradas: [] }),
            sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/clinicas/${clinica.clinica._id}`,
              "GET",
              null,
              { Authorization: "Bearer " + auth.token },
            ),
          ]);

        setContaCorrente(contaCorrenteResponse.contaCorrente);
        setEntradas(entradasResponse.entradas);
        setDadosClinica(clinicaResponse.clinica);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchData();
  }, [clienteId, sendRequest, clinica, auth.token, recarga]);

  useEffect(() => {
    let recebido = 0;
    let porReceber = 0;
    let dataParaDataGrid = [];

    if (contaCorrente && contaCorrente.contas) {
      const contasNaoLiquidadas = contaCorrente.contas;

      contasNaoLiquidadas.forEach((conta) => {
        if (conta.aprovado && conta.orcamento.ativo) {
          conta.parcelas.forEach((parcela) => {
            if (!mostrarRecebidos && parcela.parcelaPaga) return;
            recebido += parcela.quantiaPaga;
            if (parcela.status !== "CANCELADA") {
              porReceber += parcela.quantiaPorPagar;
            }
            dataParaDataGrid.push({
              tipo: "receita",
              descricao: parcela.descricao,
              orcamento: conta.orcamento,
              id: parcela._id,
              contaId: conta._id,
              dataLimitePagamento: parcela.dataLimitePagamento,
              dataPagamento: parcela.dataPagamento,
              quantiaPorPagar: parcela.quantiaPorPagar,
              quantiaPaga: parcela.quantiaPaga,
              metodoPagamento: parcela.metodoPagamento,
              nrParcela: parcela.nrParcela,
              parcelaPaga: parcela.parcelaPaga,
              // Unidade onde a parcela foi PAGA. A da caixa serve de
              // recurso para recebimentos anteriores ao carimbo.
              estabelecimento:
                parcela.estabelecimento || parcela.caixa?.estabelecimento,
              documentoEletronico: parcela.documentoEletronico,
              faturaEReciboEletronicos: parcela.faturaEReciboEletronicos,
              cancelamentosRecibosEletronicos:
                parcela.cancelamentosRecibosEletronicos,
              estado: parcela.parcelaPaga
                ? "Pago"
                : moment()
                      .startOf("day")
                      .isAfter(
                        moment(parcela.dataLimitePagamento).startOf("day"),
                      )
                  ? "Em atraso"
                  : "",
              nrRecibo: parcela.nrRecibo,
              cancelamentosDocumentosEletronicos:
                parcela.cancelamentosDocumentosEletronicos,
              status: parcela.status,
              motivoEncerramento: conta.motivoEncerramento,
              recebidoPor: parcela.recebidoPor?.user?.name || "",
              dataRecebimento: parcela.recebidoPor?.data
                ? moment(parcela.recebidoPor?.data).format("DD/MM/YYYY HH:mm")
                : "",
              emitidoPor: parcela.documentoEletronico?.usuarioEmissor?.name,
              dataEmissao: parcela.documentoEletronico?.created_at
                ? moment(parcela.documentoEletronico?.created_at).format(
                    "DD/MM/YYYY HH:mm",
                  )
                : "",
              fteEmitidoPor:
                parcela.faturaEReciboEletronicos?.fte?.usuarioEmissor?.name,
              dataEmissaoFte: parcela.faturaEReciboEletronicos?.fte?.created_at
                ? moment(
                    parcela.faturaEReciboEletronicos.fte.created_at,
                  ).format("DD/MM/YYYY HH:mm")
                : "",
              rceEmitidoPor:
                parcela.faturaEReciboEletronicos?.rce?.usuarioEmissor?.name,
              dataEmissaoRce: parcela.faturaEReciboEletronicos?.rce?.created_at
                ? moment(
                    parcela.faturaEReciboEletronicos.rce.created_at,
                  ).format("DD/MM/YYYY HH:mm")
                : "",
            });
          });
        }
      });
    }

    if (entradas && entradas.length > 0) {
      entradas.forEach((entrada) => {
        if (!mostrarRecebidos && entrada.entradaRecebida) return;
        if (entrada.entradaRecebida && entrada.valor) {
          recebido += entrada.valor;
        } else {
          porReceber += entrada.valor;
        }
        dataParaDataGrid.push({
          tipo: "entrada",
          tipoEntrada: entrada.tipo,
          id: entrada.id,
          cliente: entrada.clienteFornecedor
            ? entrada.clienteFornecedor
            : entrada.cliente,
          dataPagamento: entrada.dataPagamento,
          dataLimitePagamento: entrada.dataLimitePagamento,
          valor: entrada.valor,
          metodoPagamento: entrada.metodoPagamento,
          descricao: entrada.descricao,
          comprovativo: entrada.comprovativo,
          nrRecibo: entrada.nrRecibo,
          documentoEletronico: entrada.documentoEletronico,
          entradaRecebida: entrada.entradaRecebida,
          cancelamentosDocumentosEletronicos:
            entrada.cancelamentosDocumentosEletronicos,
          /* A unidade do movimento. As linhas de parcela já a traziam e as de
             entrada não — e como as duas grelhas partilham as mesmas colunas,
             a pastilha e o bloqueio de ações existiam mas nunca tinham por
             onde se decidir nas entradas. A caixa serve de recurso para os
             recebimentos anteriores ao carimbo. */
          estabelecimento:
            entrada.estabelecimento || entrada.caixa?.estabelecimento,
          caixa: entrada.caixa,
          recebidoPor: entrada.recebidoPor?.user?.name || "",
          dataRecebimento: entrada.recebidoPor?.data
            ? moment(entrada.recebidoPor?.data).format("DD/MM/YYYY HH:mm")
            : "",
          emitidoPor: entrada.documentoEletronico?.usuarioEmissor?.name,
          dataEmissao: entrada.documentoEletronico?.created_at
            ? moment(entrada.documentoEletronico?.created_at).format(
                "DD/MM/YYYY HH:mm",
              )
            : "",
        });
      });
    }

    dataParaDataGrid = dataParaDataGrid.sort(
      (a, b) =>
        new Date(a.dataLimitePagamento) - new Date(b.dataLimitePagamento),
    );
    setTotalRecebido(recebido.toLocaleString("pt-BR"));
    setTotalReceber(porReceber.toLocaleString("pt-BR"));
    setRows(dataGridData(dataParaDataGrid, nomeCliente));
  }, [contaCorrente, nomeCliente, mostrarRecebidos, entradas]);

  //Mui Button editarDesconto
  const [menuState, setMenuState] = React.useState({
    anchorEl: null,
    selectedConta: null,
    isClosing: false,
  });

  const handleClickMenu = (event, conta) => {
    event.preventDefault();
    event.stopPropagation();
    setMenuState({
      anchorEl: event.currentTarget,
      selectedConta: conta,
      isClosing: false,
    });
  };

  const handleCloseMenu = (event) => {
    if (event) {
      // Add this check since onClose can be called without an event
      event.preventDefault();
      event.stopPropagation();
    }
    setMenuState((prev) => ({
      ...prev,
      anchorEl: null,
      isClosing: true,
    }));
    // Clear the selected conta after the menu closing animation
    setTimeout(() => {
      setMenuState({
        anchorEl: null,
        selectedConta: null,
        isClosing: false,
      });
    }, 200); // MUI menu transition duration
  };

  const handleOpenModalReceber = (
    idParcela,
    valorParcela,
    descricaoParcela,
  ) => {
    setOpenModal("receber");
    setValor(valorParcela);
    setIdParcela(idParcela);
    setDescricaoParcela(descricaoParcela || "");
  };

  const updateContaCorrente = (
    novaContaCorrente,
    dadosEmicaoDocumento,
    tipoDocumento,
  ) => {
    if (!dadosEmicaoDocumento) {
      stopLoading();
    }

    setContaCorrente({ ...novaContaCorrente });

    if (dadosEmicaoDocumento) {
      const contaFiltrada = novaContaCorrente.contas.filter(
        (c) => c._id === dadosEmicaoDocumento.Idconta,
      )[0];

      const parcelaFiltrada = contaFiltrada.parcelas.filter(
        (p) => p._id === dadosEmicaoDocumento.IdParcela,
      )[0];

      if (tipoDocumento === "FRE") {
        emitirDocumentoFiscal("FRE", parcelaFiltrada);
      }
    }
  };

  const handleOpenModalProcedimentos = (orcamento) => {
    setModalData(orcamento);
    setOpenModal("procedimentos");
  };

  const handleCloseModal = () => {
    setOpenModal("");
    setDadosModalMotivoCancelamento({ open: false });
    setModalData(null);
  };

  //BEFORE RECEBIMENTO PARCELA
  const beforeCancelarRecebimento = (id, idConta) => {
    const copyContaCorrente = { ...contaCorrente };

    const filteredConta = copyContaCorrente.contas.filter(
      (conta) => conta._id === idConta,
    )[0];

    const oldParcela = filteredConta.parcelas.filter(
      (parcela) => parcela._id === id,
    )[0];

    const temRCESucesso =
      oldParcela.faturaEReciboEletronicos?.rce?.succeeded === true;

    const isFTESemRCE =
      oldParcela.documentoEletronico?.succeeded === true &&
      oldParcela.documentoEletronico?.tipoDocumento === "FTE" &&
      !temRCESucesso;

    if (temRCESucesso) {
      // FTE + RCE: cancelar recebimento exige Event para anular o RCE.
      // A FTE permanece — só o recibo é que se anula.
      setDadosModalMotivoCancelamento({
        open: true,
        id,
        idConta,
        tipoDocumento: "Event",
        tipoDocumentoAnular: "RCE",
        nif: clienteData.nif,
        nome: clienteData.nomeFiscal,
        tipoCancelamento: "parcelaEventParaRCE",
        valorTotal: oldParcela.quantiaPaga,
        documentoEmContingencia:
          oldParcela.faturaEReciboEletronicos?.rce?.emitidoEmContingencia ||
          false,
      });
    } else if (oldParcela.documentoEletronico?.succeeded && !isFTESemRCE) {
      // FRE / TVE: cancelar recebimento exige NCE.
      setDadosModalMotivoCancelamento({
        open: true,
        id,
        tipoDocumento: "NCE",
        tipoDocumentoAnular: oldParcela.documentoEletronico.tipoDocumento,
        nif: clienteData.nif,
        nome: clienteData.nomeFiscal,
        tipoCancelamento: "parcela",
        valorTotal: oldParcela.quantiaPaga,
        documentoEmContingencia:
          oldParcela.documentoEletronico?.emitidoEmContingencia || false,
      });
    } else {
      // Sem doc OU FTE sem RCE → rollback simples (já tratado em handleCancelarRecebimento)
      handleCancelarRecebimento(id, idConta);
    }
  };

  const marcarCanDeleteFalse = async (contaFiltrada) => {
    const nrParcelasNaoPagas = contaFiltrada.parcelas.filter(
      (p) => p.quantiaPaga === 0,
    ).length;

    //Atualizar o plano de tratamento para que este possa ser apagado
    //Caso essa for a ultima parcela recebida.
    //visto que irei passar a conta antes do cancelamento,
    //Em vez de verificar se nrParcelasNaoPagas === contaFiltrada.parcelas.length
    //verifico se nrParcelasNaoPagas === contaFiltrada.parcelas.length - 1
    if (nrParcelasNaoPagas === contaFiltrada.parcelas.length - 1) {
      let planoTratamento;
      try {
        planoTratamento = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/orcamento/${contaFiltrada.orcamento._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
      } catch (err) {
        console.error("err", err);
      }

      //Caso tivermos varios planos de tratamento com o mesmo orcamento, porque isso pode acontecer
      //Quando apagamos um plano de tratamento, filtramos apenas o ativo
      const planoTratamentoFiltrado = planoTratamento.planosTratamento.filter(
        (plano) => plano.ativo === true,
      )[0];

      const formData = new FormData();
      formData.append("canDelete", true);
      try {
        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/candelete/${planoTratamentoFiltrado._id}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
      } catch (err) {
        console.error("err", err);
      }
    }
  };

  //Parcelas Cancelar recebimento
  const handleCancelarRecebimento = async (
    id,
    motivoCancelamento,
    tipoDocumento,
    nomeENif,
    valorCancelar,
    dadosContingencia,
  ) => {
    // se for anulação de FTE pré-pagamento, segue caminho separado.
    // Esta função é também chamada para cancelar recebimento de parcela paga
    // (FRE/TVE) — esse fluxo continua intocado abaixo.
    if (dadosModalMotivoCancelamento.tipoCancelamento === "parcelaNCEParaFTE") {
      return handleAnularFTEParcela(
        id,
        motivoCancelamento,
        nomeENif,
        valorCancelar,
        dadosContingencia,
      );
    }

    if (
      dadosModalMotivoCancelamento.tipoCancelamento === "parcelaEventParaRCE"
    ) {
      // motivoCancelamento aqui é a string do motivo do Event (textarea),
      // não o objecto com cod/description.
      return handleAnularRCEParcela(id, motivoCancelamento, dadosContingencia);
    }

    startLoading();
    try {
      // Encontrar a parcela e conta
      const { parcelaFiltrada, contaFiltrada } = encontrarParcelaEConta(id);

      const isFTESemRCE =
        parcelaFiltrada.documentoEletronico?.succeeded === true &&
        parcelaFiltrada.documentoEletronico?.tipoDocumento === "FTE" &&
        !parcelaFiltrada.faturaEReciboEletronicos?.rce?.succeeded;

      if (
        !parcelaFiltrada.documentoEletronico ||
        parcelaFiltrada.documentoEletronico?.succeeded === false ||
        isFTESemRCE
      ) {
        const formData = new FormData();
        formData.append("contaCorrenteId", contaCorrente._id);
        formData.append("contaId", contaFiltrada._id);
        formData.append("parcelaId", parcelaFiltrada._id);
        formData.append("canceladoPor", auth.userId);
        formData.append("valor", parcelaFiltrada.quantiaPaga);
        formData.append("nomeCliente", contaCorrente.cliente.nome);

        // Se houver doc com erro, enviar o ID para ser deletado
        if (parcelaFiltrada.documentoEletronico?.succeeded === false) {
          formData.append(
            "docEletronicoId",
            parcelaFiltrada.documentoEletronico._id,
          );
        }

        // Se é FTE sem RCE, mantemos a FTE na parcela — só revertemos o pagamento.
        if (isFTESemRCE) {
          formData.append("manterDocumentoEletronico", "true");
        }

        const resposta = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/cancelarrecebimentosemdocumento`,
          "PATCH",
          formData,
          { Authorization: "Bearer " + auth.token },
        );

        await marcarCanDeleteFalse(contaFiltrada);

        setContaCorrente(resposta.contaCorrente);
        toast.success("Recebimento cancelado com sucesso!");
        return;
      }

      // NOVA VALIDAÇÃO: Verificar se documento original está em contingência
      const documentoOriginalEmContingencia =
        parcelaFiltrada.documentoEletronico?.emitidoEmContingencia === true;

      // Validar dados do cliente se necessário
      const validacao = validarDadosCliente(
        contaCorrente.cliente,
        tipoDocumento,
      );
      if (!validacao.valido) {
        toast.error(validacao.erro);
        return;
      }

      // Preparar dados para cancelamento
      const dadosCancelamento = {
        clinicaId: clinica.clinica._id,
        tipoDocumento,
        contaCorrenteId: contaCorrente._id,
        contaId: contaFiltrada._id,
        parcelaId: parcelaFiltrada._id,
        valor: valorCancelar || parcelaFiltrada.quantiaPaga, // MODIFICADO
        valorOriginalParcela: parcelaFiltrada.quantiaPaga, // NOVO
        cancelamentoParcial:
          valorCancelar && valorCancelar < parcelaFiltrada.quantiaPaga, // NOVO
        IUDCancelar: parcelaFiltrada.documentoEletronico.entryName.replace(
          /\.xml$/,
          "",
        ),
        idDocumentoAnular: parcelaFiltrada.documentoEletronico._id,
        clinica: {
          nif: clinica.clinica.nif,
          nomeFiscal: clinica.clinica.nomeFiscal,
          endereco: clinica.clinica.endereco,
          contacto: clinica.clinica.contacto,
          email: clinica.clinica.email,
        },
        usuarioEmissor: auth.userId,
        nomeCliente: nomeENif
          ? nomeENif.nome
          : contaCorrente.cliente.nomeFiscal,
        nifCliente: nomeENif ? nomeENif.nif : contaCorrente.cliente.nif,
        descricaoPagamento:
          parcelaFiltrada.descricao?.trim() || "Tratamento dentário",
        contactoCliente: contaCorrente.cliente.contacto,
        moradaCliente: contaCorrente.cliente.endereco,
        codigoPaisCliente: contaCorrente.cliente.pais.codigo,
        metodoPagamento: parcelaFiltrada.metodoPagamento,
        IssueReasonCode: motivoCancelamento,
        online: !documentoOriginalEmContingencia, // MODIFICADO: Se doc original em contingência, força offline
        // NOVOS CAMPOS para contingência
        emitirEmContingencia: documentoOriginalEmContingencia,
        ReasonTypeCode: dadosContingencia?.ReasonTypeCode,
        ReasonDescription: dadosContingencia?.ReasonDescription,
      };

      const formData = new FormData();
      formData.append("dadosCancelamento", JSON.stringify(dadosCancelamento));

      let resposta;
      try {
        // MODO CONTINGÊNCIA: Abre diálogo para escolher motivo
        if (
          (documentoOriginalEmContingencia && !dadosContingencia) ||
          (modoContingenciaAtivo && !dadosContingencia)
        ) {
          setDadosCancelamentoPendente({
            tipo: "cancelamentoParcela",
            dadosCancelamento,
            parcelaFiltrada,
            contaFiltrada,
          });
          setDialogContingenciaOpen(true);
          stopLoading();
          return;
        }
        // Enviar requisição de cancelamento
        resposta = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/cancelarrecebimento`,
          "POST",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
      } catch (err) {
        console.error("err", err);
      }

      // Atualizar estados locais
      setContaCorrente(resposta.contaCorrente);
      // Mostrar feedback apropriado
      if (resposta.documento?.responseData?.responses[0]?.succeeded) {
        await marcarCanDeleteFalse(contaFiltrada);

        // MODIFICADO: Mensagem diferente se foi em contingência
        const msgContingencia = documentoOriginalEmContingencia
          ? " em CONTINGÊNCIA (documento original também está offline)"
          : "";
        toast.success(
          `Recebimento cancelado com emissão de ${tipoDocumento}${msgContingencia}!`,
        );
      } else {
        toast.error(
          `Erro ao emitir ${tipoDocumento}: ${resposta.documento?.responseData?.responses[0]?.messages[0]?.description}`,
        );
      }
    } catch (err) {
      console.error("Erro ao cancelar recebimento:", err);
      toast.error("Erro ao cancelar recebimento");
    } finally {
      stopLoading();
    }
  };

  const handleAnularFTEParcela = async (
    id,
    motivoCancelamento,
    nomeENif,
    valorCancelar,
    dadosContingencia,
  ) => {
    startLoading();
    try {
      const { parcelaFiltrada, contaFiltrada } = encontrarParcelaEConta(id);

      const validacao = validarDadosCliente(contaCorrente.cliente, "NCE");
      if (!validacao.valido) {
        toast.error(validacao.erro);
        return;
      }

      const documentoOriginalEmContingencia =
        parcelaFiltrada.documentoEletronico?.emitidoEmContingencia === true;

      const valorOriginal =
        parcelaFiltrada.quantiaPorPagar || parcelaFiltrada.quantiaPaga;

      const dadosCancelamento = {
        clinicaId: clinica.clinica._id,
        tipoDocEletronico: "NCE",
        contaCorrenteId: contaCorrente._id,
        contaId: contaFiltrada._id,
        parcelaId: parcelaFiltrada._id,
        valor: valorCancelar || valorOriginal,
        valorOriginalParcela: valorOriginal,
        cancelamentoParcial: valorCancelar && valorCancelar < valorOriginal,
        IUDCancelar: parcelaFiltrada.documentoEletronico.entryName.replace(
          /\.xml$/,
          "",
        ),
        idDocumentoAnular: parcelaFiltrada.documentoEletronico._id,
        clinica: {
          nif: clinica.clinica.nif,
          nomeFiscal: clinica.clinica.nomeFiscal,
          endereco: clinica.clinica.endereco,
          contacto: clinica.clinica.contacto,
          email: clinica.clinica.email,
        },
        usuarioEmissor: auth.userId,
        nomeCliente: nomeENif
          ? nomeENif.nome
          : contaCorrente.cliente.nomeFiscal,
        nifCliente: nomeENif ? nomeENif.nif : contaCorrente.cliente.nif,
        descricaoPagamento:
          parcelaFiltrada.descricao?.trim() || "Tratamento dentário",
        contactoCliente: contaCorrente.cliente.contacto,
        moradaCliente: contaCorrente.cliente.endereco,
        codigoPaisCliente: contaCorrente.cliente.pais.codigo,
        metodoPagamento: parcelaFiltrada.metodoPagamento,
        IssueReasonCode: motivoCancelamento,
        online: !documentoOriginalEmContingencia,
        emitirEmContingencia: documentoOriginalEmContingencia,
        ReasonTypeCode: dadosContingencia?.ReasonTypeCode,
        ReasonDescription: dadosContingencia?.ReasonDescription,
      };

      // Se documento original em contingência OU modo contingência ativo,
      // abre diálogo de contingência primeiro.
      if (
        (documentoOriginalEmContingencia && !dadosContingencia) ||
        (modoContingenciaAtivo && !dadosContingencia)
      ) {
        setDadosCancelamentoPendente({
          tipo: "anularFTEParcela",
          dadosCancelamento,
        });
        setDialogContingenciaOpen(true);
        stopLoading();
        return;
      }

      await executarEmissaoNCEParcelaComFTE(dadosCancelamento);
    } catch (err) {
      console.error("Erro ao anular FTE:", err);
      toast.error("Erro ao anular FTE");
    } finally {
      stopLoading();
    }
  };

  const executarAnularRCEParcela = async (dadosCancelamento) => {
    const formData = new FormData();
    formData.append("dadosCancelamento", JSON.stringify(dadosCancelamento));

    const resposta = await sendRequest(
      `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/parcelas/cancelarrecebimentorce`,
      "POST",
      formData,
      { Authorization: "Bearer " + auth.token },
    );

    if (!resposta) throw new Error("Não houve resposta do servidor");

    setContaCorrente(resposta.contaCorrente);

    if (resposta.documento?.respostaEfatura?.responses[0]?.succeeded) {
      const msgContingencia = resposta.documento?.emitidoEmContingencia
        ? " em CONTINGÊNCIA"
        : "";
      toast.success(
        `Recebimento cancelado com emissão de Event${msgContingencia}`,
      );
    } else {
      toast.error(
        `Erro ao emitir Event: ${resposta.documento?.respostaEfatura?.responses[0]?.messages?.[0]?.description}`,
      );
    }
  };

  const handleAnularRCEParcela = async (id, motivoEvent, dadosContingencia) => {
    startLoading();
    try {
      const { parcelaFiltrada, contaFiltrada } = encontrarParcelaEConta(id);

      const documentoOriginalEmContingencia =
        parcelaFiltrada.faturaEReciboEletronicos?.rce?.emitidoEmContingencia ===
        true;

      const dadosCancelamento = {
        clinicaId: clinica.clinica._id,
        tipoDocEletronico: "Event",
        contaCorrenteId: contaCorrente._id,
        contaId: contaFiltrada._id,
        parcelaId: parcelaFiltrada._id,
        valor: parcelaFiltrada.quantiaPaga,
        usuarioEmissor: auth.userId,
        clinica: {
          nif: clinica.clinica.nif,
          nomeFiscal: clinica.clinica.nomeFiscal,
          endereco: clinica.clinica.endereco,
          contacto: clinica.clinica.contacto,
          email: clinica.clinica.email,
        },
        nomeCliente: contaCorrente.cliente.nomeFiscal,
        IUDCancelar:
          parcelaFiltrada.faturaEReciboEletronicos.rce.entryName.replace(
            /\.xml$/,
            "",
          ),
        idDocumentoAnular: parcelaFiltrada.faturaEReciboEletronicos.rce._id,
        IssueReasonDescription: motivoEvent,
        online: !documentoOriginalEmContingencia,
        emitirEmContingencia: documentoOriginalEmContingencia,
        motivoContingencia: documentoOriginalEmContingencia
          ? `Anulação de RCE emitido em contingência (${parcelaFiltrada.faturaEReciboEletronicos.rce.entryName})`
          : undefined,
        ReasonTypeCode: dadosContingencia?.ReasonTypeCode,
        ReasonDescription: dadosContingencia?.ReasonDescription,
      };

      if (
        (documentoOriginalEmContingencia && !dadosContingencia) ||
        (modoContingenciaAtivo && !dadosContingencia)
      ) {
        setDadosCancelamentoPendente({
          tipo: "anularRCEParcela",
          dadosCancelamento,
        });
        setDialogContingenciaOpen(true);
        stopLoading();
        return;
      }

      await executarAnularRCEParcela(dadosCancelamento);
    } catch (err) {
      console.error("Erro ao anular RCE:", err);
      toast.error("Erro ao anular RCE");
    } finally {
      stopLoading();
    }
  };

  // Anular Recibo Interno - Parcelas
  const handleAnularReciboInterno = async (id, idConta) => {
    startLoading();
    try {
      const contaFiltrada = contaCorrente.contas.filter(
        (conta) => conta._id === idConta,
      )[0];

      const parcelaFiltrada = contaFiltrada.parcelas.filter(
        (parcela) => parcela._id === id,
      )[0];

      if (!parcelaFiltrada.nrRecibo) {
        toast.error("Esta parcela não possui recibo interno!");
        return;
      }

      const formData = new FormData();
      formData.append("parcelaId", id);
      formData.append("contaId", idConta);
      formData.append("utilizador", auth.userId);
      formData.append("nomeCliente", contaCorrente.cliente.nome);

      const contaCorrenteRetornada = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/anularrecibo/${contaCorrente._id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      updateContaCorrente(contaCorrenteRetornada.contaCorrente);
      toast.success("Recibo interno anulado com sucesso!");
    } catch (err) {
      console.error("Erro ao anular recibo interno:", err);
      toast.error("Erro ao anular recibo interno");
    } finally {
      stopLoading();
    }
  };

  // Anular Recibo Interno - Entradas
  const handleAnularReciboInternoEntrada = async (idEntrada) => {
    startLoading();
    try {
      const entradaFiltrada = entradas.find((e) => e._id === idEntrada);

      if (!entradaFiltrada) {
        toast.error("Entrada não encontrada!");
        return;
      }

      if (!entradaFiltrada.nrRecibo) {
        toast.error("Esta entrada não possui recibo interno!");
        return;
      }

      const formData = new FormData();
      formData.append("utilizador", auth.userId);

      const tempEntradaRetornada = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/anularrecibo/${idEntrada}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      updateEntradas(tempEntradaRetornada.entrada, "atualizar");
      toast.success("Recibo interno anulado com sucesso!");
    } catch (err) {
      console.error("Erro ao anular recibo interno:", err);
      toast.error("Erro ao anular recibo interno");
    } finally {
      stopLoading();
    }
  };

  const verReceitaHandler = (id, idConta) => {
    const contaFiltrada = contaCorrente.contas.filter(
      (conta) => conta._id === idConta,
    )[0];
    const parcelaFiltrada = contaFiltrada.parcelas.filter(
      (parcela) => parcela._id === id,
    )[0];

    const dadosReceita = {
      /* Sem isto a janela não sabe QUE parcela está a mostrar. Era só para
         ler, e passou a ser preciso para corrigir a caixa. */
      id: parcelaFiltrada._id,
      metodoPagamento: parcelaFiltrada.metodoPagamento,
      valorPago: parcelaFiltrada.quantiaPaga,
      dataRecebimento: parcelaFiltrada.dataPagamento,
      observacao: parcelaFiltrada.observacao,
      caixa: parcelaFiltrada.caixa,
      recebidoPor: parcelaFiltrada.recebidoPor?.user?.name,
    };

    if (parcelaFiltrada.cartao) dadosReceita.cartao = parcelaFiltrada.cartao;
    if (parcelaFiltrada.documentoEletronico)
      dadosReceita.documentoEletronico = parcelaFiltrada.documentoEletronico;
    if (parcelaFiltrada.metodoPagamento === "Cheque") {
      dadosReceita.nrCheque = parcelaFiltrada.nrCheque;
      dadosReceita.dataCheque = parcelaFiltrada.dataCheque;
      dadosReceita.contaCliente = parcelaFiltrada.nrContaCliente;
      dadosReceita.banco = parcelaFiltrada.banco;
    }

    setModalData(dadosReceita);
    setOpenModal("verReceita");
  };

  const gerarPdfFaturaEletronicaHandler = async (
    id,
    idConta,
    tipo,
    parCancelamento,
  ) => {
    const contaFiltrada = contaCorrente.contas.filter(
      (conta) => conta._id === idConta,
    )[0];

    const parcelaFiltrada = contaFiltrada.parcelas.filter(
      (parcela) => parcela._id === id,
    )[0];

    if (tipo === "NCE") {
      dadosFatura({
        show: true,
        // Morada da unidade que EMITIU o documento, não da que está a imprimir.
        clinica: dadosImpressao(
          dadosClinica,
          parCancelamento.documentoCancelamento.estabelecimento,
        ),
        cliente: clienteData,
        valor: parCancelamento.documentoCancelamento.valor,
        nrDocumento: parCancelamento.documentoCancelamento.nrDocumento,
        dataDocumento: parCancelamento.documentoCancelamento.authorizedDateTime,
        dataVencimento: null,
        entryName: parCancelamento.documentoCancelamento.entryName,
        serie: parCancelamento.documentoCancelamento.serie,
        tipoDocumento: parCancelamento.documentoCancelamento.tipoDocumento,
        emitidoEmContingencia:
          parCancelamento.documentoCancelamento.emitidoEmContingencia,
        usuarioEmissor:
          parCancelamento.documentoCancelamento.usuarioEmissor?.name,
        referencia: parCancelamento?.documento?.entryName,
        nrDocumentoAnulado: parCancelamento?.documento?.nrDocumento,
        tipoDocumentoAnulado: parCancelamento?.documento?.tipoDocumento,
        anoDocumentoAnulado: moment(
          parCancelamento?.documento?.authorizedDateTime,
        ).year(),
      });
    } else {
      dadosFatura({
        clinica: dadosImpressao(
          dadosClinica,
          parcelaFiltrada.documentoEletronico.estabelecimento,
        ),
        cliente: clienteData,
        valor: parcelaFiltrada.documentoEletronico.valor,
        nrDocumento: parcelaFiltrada.documentoEletronico.nrDocumento,
        dataDocumento: parcelaFiltrada.documentoEletronico.authorizedDateTime,
        dataPagamento: parcelaFiltrada.dataPagamento,
        dataVencimento: parcelaFiltrada.dataLimitePagamento,
        medico_responsavel: contaFiltrada.orcamento.medico_responsavel,
        designacao:
          parcelaFiltrada.descricao && parcelaFiltrada.descricao.trim() !== ""
            ? parcelaFiltrada.descricao
            : "Tratamento Dentário",
        metodoPagamento: parcelaFiltrada.metodoPagamento,
        entryName: parcelaFiltrada.documentoEletronico.entryName,
        serie: parcelaFiltrada.documentoEletronico.serie,
        tipoDocumento: parcelaFiltrada.documentoEletronico.tipoDocumento,
        emitidoEmContingencia:
          parcelaFiltrada.documentoEletronico.emitidoEmContingencia,
        usuarioEmissor:
          parcelaFiltrada.documentoEletronico.usuarioEmissor?.name,
      });
    }
  };

  const gerarPdfFaturaEletronicaHandlerEntrada = async (
    entradaId,
    tipo,
    parCancelamento,
  ) => {
    const entradaFiltrada = entradas.find((e) => e.id === entradaId);

    if (tipo === "NCE") {
      dadosFatura({
        show: true,
        // Morada da unidade que EMITIU a nota de crédito, não da que está a
        // imprimir. Era o único caminho de impressão deste ecrã sem isto.
        clinica: dadosImpressao(
          dadosClinica,
          parCancelamento.documentoCancelamento?.estabelecimento,
        ),
        cliente: clienteData,
        valor: parCancelamento.documentoCancelamento.valor,
        nrDocumento: parCancelamento.documentoCancelamento.nrDocumento,
        dataDocumento: parCancelamento.documentoCancelamento.dataEmissao,
        dataVencimento: null,
        entryName: parCancelamento.documentoCancelamento.entryName,
        serie: parCancelamento.documentoCancelamento.serie,
        tipoDocumento: parCancelamento.documentoCancelamento.tipoDocumento,
        emitidoEmContingencia:
          parCancelamento.documentoCancelamento.emitidoEmContingencia,
        usuarioEmissor:
          parCancelamento.documentoCancelamento.usuarioEmissor?.name,
        referencia: parCancelamento?.documento?.entryName,
        nrDocumentoAnulado: parCancelamento?.documento?.nrDocumento,
        tipoDocumentoAnulado: parCancelamento?.documento?.tipoDocumento,
        anoDocumentoAnulado: moment(
          parCancelamento?.documento?.authorizedDateTime,
        ).year(),
      });
    } else {
      dadosFatura({
        clinica: dadosImpressao(
          dadosClinica,
          entradaFiltrada.documentoEletronico.estabelecimento,
        ),
        cliente: clienteData,
        valor: entradaFiltrada.documentoEletronico.valor,
        nrDocumento: entradaFiltrada.documentoEletronico.nrDocumento,
        dataDocumento: entradaFiltrada.documentoEletronico.authorizedDateTime,
        dataPagamento: entradaFiltrada.dataPagamento,
        dataVencimento: entradaFiltrada.dataLimitePagamento,
        designacao: entradaFiltrada.descricao,
        metodoPagamento: entradaFiltrada.metodoPagamento,
        entryName: entradaFiltrada.documentoEletronico.entryName,
        serie: entradaFiltrada.documentoEletronico.serie,
        tipoDocumento: entradaFiltrada.documentoEletronico.tipoDocumento,
        emitidoEmContingencia:
          entradaFiltrada.documentoEletronico.emitidoEmContingencia,
        usuarioEmissor:
          entradaFiltrada.documentoEletronico.usuarioEmissor?.name,
      });
    }
  };

  const gerarPdfRceParcelaHandler = (id, idConta) => {
    const contaFiltrada = contaCorrente.contas.filter(
      (conta) => conta._id === idConta,
    )[0];

    const parcelaFiltrada = contaFiltrada.parcelas.filter(
      (parcela) => parcela._id === id,
    )[0];

    const rce = parcelaFiltrada.faturaEReciboEletronicos?.rce;
    const fte = parcelaFiltrada.faturaEReciboEletronicos?.fte;

    if (!rce?.succeeded) {
      toast.error("Esta parcela não possui um RCE bem-sucedido");
      return;
    }

    showRce({
      show: true,
      clinica: dadosImpressao(dadosClinica, rce.estabelecimento),
      cliente: clienteData,
      metodoPagamento: parcelaFiltrada.metodoPagamento,
      dataPagamento: parcelaFiltrada.dataPagamento,
      designacao: parcelaFiltrada.descricao?.trim() || "Tratamento Dentário",
      valor: rce.valor,
      nrDocumento: rce.nrDocumento,
      dataDocumento: rce.authorizedDateTime,
      entryName: rce.entryName,
      serie: rce.serie,
      tipoDocumento: rce.tipoDocumento,
      emitidoEmContingencia: rce.emitidoEmContingencia,
      referencia: fte?.entryName, // a FTE de referência (par FTE+RCE)
      usuarioEmissor: rce.usuarioEmissor?.name,
    });
  };

  const beforeGerarReciboHandler = async (id, idConta) => {
    startLoading();
    try {
      const contaFiltrada = contaCorrente.contas.filter(
        (conta) => conta._id === idConta,
      )[0];

      const parcelaFiltrada = contaFiltrada.parcelas.filter(
        (parcela) => parcela._id === id,
      )[0];

      if (parcelaFiltrada.nrRecibo) {
        gerarPdfReciboHandler(parcelaFiltrada, parcelaFiltrada.nrRecibo);
      } else {
        try {
          const formData = new FormData();
          formData.append("parcelaId", id);
          formData.append("contaId", idConta);
          formData.append("utilizador", auth.userId);
          formData.append("nomeCliente", contaCorrente.cliente.nome);

          //Na backend, documento eletronico é removido da parcela
          const contaCorrenteRetornada = await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/gerarrecibo/${contaCorrente._id}`,
            "PATCH",
            formData,
            {
              Authorization: "Bearer " + auth.token,
            },
          );
          updateContaCorrente(contaCorrenteRetornada.contaCorrente);
        } catch (err) {
          console.error(
            "Erro na atualização da conta corrente. Por favor tente novamente.",
            err,
          );
        }
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const gerarPdfReciboHandler = async (parcelaFiltrada, nrRecibo) => {
    dadosRecibo({
      // O recibo interno não é DFE e não guarda unidade: usa a da caixa onde o
      // dinheiro entrou, que é a mesma que determina o LED dos DFEs.
      clinica: dadosImpressao(
        dadosClinica,
        parcelaFiltrada.caixa?.estabelecimento,
      ),
      cliente: clienteData,
      valor: parcelaFiltrada.quantiaPaga || parcelaFiltrada.valor,
      nrRecibo: nrRecibo,
      descricao: parcelaFiltrada.descricao,
      dataReciboInterno: parcelaFiltrada.dataReciboInterno,
    });
  };

  const handleBeforeNCEParcela = (id, idConta) => {
    const { parcelaFiltrada } = encontrarParcelaEConta(id);

    if (!parcelaFiltrada?.documentoEletronico?.succeeded) {
      toast.error("Esta parcela não possui FTE para anular");
      return;
    }

    setDadosModalMotivoCancelamento({
      open: true,
      id,
      contaId: idConta,
      tipoDocumento: "NCE",
      tipoDocumentoAnular: parcelaFiltrada.documentoEletronico.tipoDocumento, // "FTE"
      nif: clienteData.nif,
      nome: clienteData.nomeFiscal,
      tipoCancelamento: "parcelaNCEParaFTE", // flag nova — distingue do cancelar recebimento
      valorTotal:
        parcelaFiltrada.quantiaPorPagar || parcelaFiltrada.quantiaPaga,
      documentoEmContingencia:
        parcelaFiltrada.documentoEletronico?.emitidoEmContingencia || false,
    });
  };

  const handleBeforeEmitirDocEletronico = (id, idConta, tipoDocumento) => {
    const contaFiltrada = contaCorrente.contas.filter(
      (conta) => conta._id === idConta,
    )[0];

    const parcelaFiltrada = contaFiltrada.parcelas.filter(
      (parcela) => parcela._id === id,
    )[0];

    verificarEEmitirDocumento(tipoDocumento, parcelaFiltrada);
  };

  // Função para encontrar a parcela e conta correta
  const encontrarParcelaEConta = (parcela) => {
    let parcelaFiltrada = parcela;
    let contaFiltrada;

    // Pode ser enviado o id da parcela ou a própria parcela
    if (parcela._id) {
      contaCorrente.contas.forEach((conta) => {
        conta.parcelas.forEach((p) => {
          if (p._id === parcela._id) contaFiltrada = conta;
        });
      });
    } else {
      contaCorrente.contas.forEach((conta) => {
        conta.parcelas.forEach((p) => {
          if (p._id === parcela) {
            contaFiltrada = conta;
            parcelaFiltrada = p;
          }
        });
      });
    }

    return { parcelaFiltrada, contaFiltrada };
  };

  // Função principal
  const emitirDocumentoFiscal = async (tipoDocumento, parcela) => {
    startLoading();
    let dadosEmissao;
    try {
      setOpenModal("");

      // Validamos os dados do cliente antes de fazer qualquer chamada ao backend
      const validacao = validarDadosCliente(
        contaCorrente.cliente,
        tipoDocumento,
      );
      if (!validacao.valido) {
        toast.error(validacao.erro);
        stopLoading();
        return;
      }

      // Encontramos a parcela e conta corretos no frontend pois precisamos destes dados para a interface
      const { parcelaFiltrada, contaFiltrada } =
        encontrarParcelaEConta(parcela);

      // Preparamos todos os dados necessários em um único objeto
      dadosEmissao = {
        // Dados do documento

        tipoDocEletronico: tipoDocumento,
        valor: parcelaFiltrada.quantiaPaga,
        descricaoPagamento:
          parcelaFiltrada.descricao?.trim() || "Tratamento dentário",
        metodoPagamento: parcelaFiltrada.metodoPagamento,
        dataPagamento: parcelaFiltrada.dataPagamento,
        usuarioEmissor: auth.userId,
        online: true,

        // IDs para atualização da conta corrente
        contaCorrenteId: contaCorrente._id,
        contaId: contaFiltrada._id,
        parcelaId: parcelaFiltrada._id,

        // Dados do cliente (exceto para TVE)
        ...(tipoDocumento !== "TVE" && {
          nomeCliente: contaCorrente.cliente.nomeFiscal,
          nifCliente: contaCorrente.cliente.nif,
          contactoCliente: contaCorrente.cliente.contacto,
          codigoPaisCliente: contaCorrente.cliente.pais.codigo,
          moradaCliente: contaCorrente.cliente.endereco,
        }),
        //Dados da clinica
        clinicaId: clinica.clinica._id,
        clinica: {
          nif: clinica.clinica.nif,
          nomeFiscal: clinica.clinica.nomeFiscal,
          endereco: clinica.clinica.endereco,
          contacto: clinica.clinica.contacto,
          email: clinica.clinica.email,
        },
        // Se existe documento com erro, enviamos seu ID para ser deletado
        documentoADeletar:
          (tipoDocumento === "FRE" || tipoDocumento === "TVE") &&
          parcelaFiltrada.documentoEletronico?.succeeded === false
            ? parcelaFiltrada.documentoEletronico._id
            : null,
      };

      if (modoContingenciaAtivo) {
        setDadosContingenciaPendente({
          tipo: "parcela",
          tipoDocumento,
          parcela,
          dados: dadosEmissao,
        });
        setDialogContingenciaOpen(true);
        stopLoading();
        return;
      }

      // NOVA LÓGICA: Usa função auxiliar
      await executarEmissaoParcela(dadosEmissao);
    } catch (err) {
      console.error("Erro ao emitir documento:", err);
      // Se não for erro de contingência, mostra erro normal
      toast.error("Ocorreu um erro ao emitir o documento");
    } finally {
      stopLoading();
    }
  };

  const handleOpenModalEditarDesconto = (conta) => {
    setModalData(conta);
    setOpenModal("editarDesconto");
  };

  const handleOpenModalEditarMajoracao = (conta) => {
    setModalData(conta);
    setOpenModal("editarMajoracao");
  };

  const handleOpenModalCancelamentoPendencias = (conta) => {
    setModalData(conta);
    setOpenModal("cancelarPendencias");
  };

  const verEntradaHandler = (id) => {
    const entradaFiltrada = entradas.filter((entr) => entr.id === id)[0];
    setModalData(entradaFiltrada);
    setOpenModal("verEntrada");
  };

  const handleRestaurarPendencias = async (conta) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("contaCorrenteId", contaCorrente._id);
      formData.append("contaId", conta._id);

      const contaCorrenteRetornada = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/restaurarPendencias/${clinica.clinica._id}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );
      toast.success("Conta restaurada com sucesso!");
      updateContaCorrente(contaCorrenteRetornada.contaCorrente);
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
      handleModalCancel();
    }
  };

  const desativarEntradaHandler = async (id) => {
    startLoading();
    const filteredEntrada = entradas.find((e) => e._id === id);
    try {
      const formDataEntradaDesativar = new FormData();
      formDataEntradaDesativar.append("utilizador", auth.userId);
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/toggleativo/${id}`,
        "PATCH",
        formDataEntradaDesativar,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      //Se a entrada for referente à cobrança de uma avaliação, essa avaliação deixa de ser debitada
      if (filteredEntrada.avaliacao) {
        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/avaliacoes/removerdebitodeavaliacao/${filteredEntrada.avaliacao}`,
          "PATCH",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
      }

      const tempEntradas = [...entradas];

      const indexEntrada = tempEntradas.findIndex(
        (entrada) => entrada._id === id,
      );
      tempEntradas.splice(indexEntrada, 1);
      setEntradas([...tempEntradas]);

      toast.success(
        `Entrada desativada com sucesso!${
          filteredEntrada.avaliacao
            ? " A avaliação volta ao estado não debitado."
            : ""
        }`,
      );
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const editarEntradaHandler = (id) => {
    const entradaFiltrada = entradas.find((e) => e._id === id);
    if (!entradaFiltrada) {
      toast.error("Entrada não encontrada!");
      return;
    }
    setModalData({ open: "editarEntrada", entrada: entradaFiltrada });
  };

  const updateEntradas = (entradaRetornada, action) => {
    // Usa atualização funcional para não depender do valor de `entradas` em
    // closure (evita perder inserções feitas na mesma execução). O "inserir" é
    // idempotente: se a entrada já existir, atualiza-a em vez de duplicar.
    setEntradas((prev) => {
      const existe = prev.some((e) => e._id === entradaRetornada._id);
      if (action === "inserir" && !existe) {
        return [...prev, entradaRetornada];
      }
      return prev.map((e) =>
        e._id === entradaRetornada._id ? entradaRetornada : e,
      );
    });
    stopLoading();
  };

  //Emitir FRE ou TVE para Entradas
  const emitirDocEletronicoEntradas = async (
    entrada,
    idEntrada,
    tipoDocumento,
    operacao,
  ) => {
    startLoading();
    let dadosEmissao;
    try {
      let entradaFiltrada =
        entrada || entradas.find((e) => e._id === idEntrada);

      // Validate client data
      const validacao = validarDadosCliente(clienteData, tipoDocumento);
      if (!validacao.valido) {
        toast.error(validacao.erro);
        updateEntradas(entradaFiltrada, operacao);
        return;
      }

      // Prepare emission data
      dadosEmissao = {
        clinicaId: clinica.clinica._id,
        tipoDocEletronico: tipoDocumento,
        valor: entradaFiltrada.valor,
        descricaoPagamento: entradaFiltrada.descricao,
        metodoPagamento: entradaFiltrada.metodoPagamento,
        usuarioEmissor: auth.userId,
        entrada: entradaFiltrada._id,
        dataPagamento: entradaFiltrada.dataPagamento,
        online: true,
        clinica: {
          nif: clinica.clinica.nif,
          nomeFiscal: clinica.clinica.nomeFiscal,
          endereco: clinica.clinica.endereco,
          contacto: clinica.clinica.contacto,
          email: clinica.clinica.email,
        },
        ...(tipoDocumento !== "TVE" && {
          nomeCliente: clienteData.nomeFiscal,
          nifCliente: clienteData.nif,
          contactoCliente: clienteData.contacto,
          moradaCliente: clienteData.endereco,
          codigoPaisCliente: clienteData.pais.codigo,
        }),
      };

      if (modoContingenciaAtivo) {
        setDadosContingenciaPendente({
          tipo: "entrada",
          entrada,
          idEntrada,
          tipoDocumento,
          operacao,
          dados: dadosEmissao,
        });
        setDialogContingenciaOpen(true);
        stopLoading();
        return;
      }

      await executarEmissaoEntrada(dadosEmissao, operacao);
    } catch (err) {
      console.error("Erro ao emitir documento:", err);
      toast.error("Ocorreu um erro ao emitir o documento");
    } finally {
      stopLoading();
    }
  };

  const gerarReciboInternoEntradas = async (idEntrada) => {
    startLoading();
    try {
      const entradaFiltrada = entradas.find((e) => e._id === idEntrada);
      let entradaRetornada;
      if (entradaFiltrada.nrRecibo) {
        gerarPdfReciboHandler(entradaFiltrada, entradaFiltrada.nrRecibo);
      } else {
        try {
          const formData = new FormData();
          formData.append("utilizador", auth.userId);

          //Na backend, documento eletronico é removido da entrada
          const tempEntradaRetornada = await sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/gerarrecibo/${idEntrada}`,
            "PATCH",
            formData,
            {
              Authorization: "Bearer " + auth.token,
            },
          );

          entradaRetornada = tempEntradaRetornada.entrada;

          toast.success("Recibo gerado com sucesso!");
          updateEntradas(entradaRetornada, "atualizar");
        } catch (err) {
          console.error("err", err);
        }
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const handleOpenModalReceberEntrada = (id) => {
    const entradaFiltada = entradas.find((e) => e.id === id);
    if (!entradaFiltada) {
      toast.error("Não foi possivel encontrar a entrada");
      return;
    }
    setModalData({ open: "receberEntrada", entrada: entradaFiltada });
  };

  //BEFORE RECEBIMENTO ENTRADA
  const handleBeforeCancelarRecebimentoEntrada = (
    id,
    enviarDocCancelamento,
  ) => {
    const entradaFiltrada = entradas.find((e) => e.id === id);
    if (!entradaFiltrada) {
      toast.error("Entrada não encontrada!");
      return;
    }
    if (enviarDocCancelamento) {
      setDadosModalMotivoCancelamento({
        open: true,
        entrada: entradaFiltrada,
        tipoDocumento: "NCE",
        tipoDocumentoAnular: entradaFiltrada.documentoEletronico.tipoDocumento,
        nif: clienteData.nif,
        nome: clienteData.nomeFiscal,
        tipoCancelamento: "entrada",
        documentoEmContingencia:
          entradaFiltrada.documentoEletronico?.emitidoEmContingencia || false,
      });
    } else {
      handleCancelarRecebimentoEntrada(entradaFiltrada);
    }
  };

  //CANCELAR RECEBIMENTO ENTRADAS
  const handleCancelarRecebimentoEntrada = async (
    entradaFiltrada,
    enviarDocCancelamento,
    motivoCancelamento,
    tipoDocumento,
    nomeENif,
    dadosContingencia,
  ) => {
    startLoading();
    try {
      if (!enviarDocCancelamento) {
        // Simple cancellation without document
        const formData = new FormData();
        formData.append("canceladoPor", auth.userId);
        const result = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/cancelarrecebimentosemdocumento/${entradaFiltrada._id}`,
          "PATCH",
          formData,
          { Authorization: "Bearer " + auth.token },
        );

        updateEntradas(result.entrada, "atualizar");
        toast.success("Recebimento cancelado com sucesso!");
        return;
      }

      // NOVA VALIDAÇÃO: Verificar se documento original está em contingência
      const documentoOriginalEmContingencia =
        entradaFiltrada.documentoEletronico?.emitidoEmContingencia === true;

      // Prepare cancellation data
      const dadosCancelamento = {
        clinicaId: clinica.clinica._id,
        tipoDocEletronico: tipoDocumento,
        entradaId: entradaFiltrada._id,
        valor: entradaFiltrada.valor,
        usuarioEmissor: auth.userId,
        clinica: {
          nif: clinica.clinica.nif,
          nomeFiscal: clinica.clinica.nomeFiscal,
          endereco: clinica.clinica.endereco,
          contacto: clinica.clinica.contacto,
          email: clinica.clinica.email,
        },
        IUDCancelar: entradaFiltrada.documentoEletronico.entryName.replace(
          /\.xml$/,
          "",
        ),
        idDocumentoAnular: entradaFiltrada.documentoEletronico._id,
        IssueReasonCode: motivoCancelamento,
        nomeCliente: nomeENif ? nomeENif.nome : clienteData.nomeFiscal,
        nifCliente: nomeENif ? nomeENif.nif : clienteData.nif,
        descricaoPagamento: entradaFiltrada.descricao,
        contactoCliente: clienteData.contacto,
        moradaCliente: clienteData.endereco,
        codigoPaisCliente: clienteData.pais.codigo,
        metodoPagamento: entradaFiltrada.metodoPagamento,
        dataPagamento: entradaFiltrada.dataPagamento,
        online: !documentoOriginalEmContingencia,
        emitirEmContingencia: documentoOriginalEmContingencia,
        ReasonTypeCode: dadosContingencia?.ReasonTypeCode,
        ReasonDescription: dadosContingencia?.ReasonDescription,
      };

      const formData = new FormData();
      formData.append("dadosCancelamento", JSON.stringify(dadosCancelamento));

      let resposta;
      try {
        // MODO CONTINGÊNCIA: Abre diálogo para escolher motivo
        if (
          (documentoOriginalEmContingencia && !dadosContingencia) ||
          (modoContingenciaAtivo && !dadosContingencia)
        ) {
          setDadosCancelamentoPendente({
            tipo: "cancelamentoEntrada",
            dadosCancelamento,
            entradaFiltrada,
          });
          setDialogContingenciaOpen(true);
          stopLoading();
          return;
        }
        resposta = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/cancelarrecebimentocomdocumento`,
          "POST",
          formData,
          { Authorization: "Bearer " + auth.token },
        );
      } catch (err) {
        console.error("err", err);
      }

      updateEntradas(resposta.entrada, "atualizar");
      if (resposta.documento?.responseData?.responses[0]?.succeeded) {
        const msgContingencia = documentoOriginalEmContingencia
          ? " em CONTINGÊNCIA (documento original também está offline)"
          : "";
        toast.success(
          `Recebimento cancelado e ${tipoDocumento} emitido com sucesso${msgContingencia}!`,
        );
      } else {
        toast.error(
          `Erro ao emitir ${tipoDocumento}: ${resposta.documento?.responseData?.responses[0]?.messages[0]?.description}`,
        );
      }
    } catch (err) {
      console.error("Erro ao cancelar recebimento:", err);
      toast.error("Erro ao cancelar recebimento");
    } finally {
      stopLoading();
    }
  };

  const actionColumn = [
    {
      field: "data",
      headerName: "Data",
      flex: 1,
      renderCell: (params) => {
        return (
          <div>
            {params.row.tipo === "receita" && (
              <span
                className={
                  params.row.parcelaPaga && params.row.status !== "CANCELADA"
                    ? "spanCellPago"
                    : ""
                }
              >
                {params.row.dataPagamento
                  ? moment(params.row.dataPagamento).format("DD-MM-YYYY")
                  : moment(params.row.dataLimitePagamento).format("DD-MM-YYYY")}
              </span>
            )}

            {params.row.tipo === "entrada" && (
              <div
                className={
                  params.row.entradaRecebida && params.row.dataPagamento
                    ? "spanCellPago"
                    : !params.row.entradaRecebida &&
                        moment().isAfter(
                          moment(params.row.dataLimitePagamento),
                          "day",
                        )
                      ? "spanCellAtraso"
                      : ""
                }
              >
                {params.row.entradaRecebida && params.row.dataPagamento
                  ? moment(params.row.dataPagamento).format("DD-MM-YYYY")
                  : moment(params.row.dataLimitePagamento).format("DD-MM-YYYY")}
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "nome",
      headerName: "Nome",
      flex: 6,
      renderCell: (params) => {
        return (
          <>
            {params.row.tipo === "receita" && (
              <div className="cellDebitoNome">
                {/* A unidade vem ANTES do número da parcela: diz de onde é a
                    linha, e isso lê-se primeiro.

                    Só em parcelas PAGAS. Numa por pagar o `estabelecimento` é
                    a unidade do ORÇAMENTO — uma previsão de onde virá a ser
                    paga, não um facto. Mostrar «recebimento de outra unidade»
                    num recebimento que ainda não aconteceu é dizer uma coisa
                    que não é verdade. */}
                {params.row.parcelaPaga && (
                  <>
                    <BadgeUnidade
                      estabelecimento={
                        params.row.estabelecimento ||
                        params.row.caixa?.estabelecimento
                      }
                      prefixo="Recebido em"
                    />
                    {/* «Recebimento de outra unidade» e não «só consulta»: a
                        VENDA continua a poder gerir-se daqui — é o recebimento
                        que é de lá. Um aviso que exagera ensina a desconfiar
                        dele. */}
                    <SeloSoConsulta
                      estabelecimento={
                        params.row.estabelecimento ||
                        params.row.caixa?.estabelecimento
                      }
                      texto="recebimento de outra unidade"
                    />{" "}
                  </>
                )}

                {params.row.nrParcela && (
                  <Tooltip
                    title={`Parcelado em ${params.row.nrParcela?.[2]} vezes`}
                  >
                    <IconButton>
                      <span className="nrParcela">{params.row.nrParcela}</span>
                    </IconButton>
                  </Tooltip>
                )}

                {params.row.descricao !== "Tratamento dentário" ||
                params.row.status === "CANCELADA" ? (
                  <span
                    className={
                      params.row.parcelaPaga &&
                      params.row.status !== "CANCELADA"
                        ? "spanCellPago"
                        : ""
                    }
                  >
                    {params.row.descricao
                      ? params.row.descricao
                      : params.row.status === "CANCELADA"
                        ? "Parcela Consolidade - Valores não pagos"
                        : params.row.nome}
                  </span>
                ) : (
                  <span
                    className={
                      params.row.parcelaPaga &&
                      params.row.status !== "CANCELADA"
                        ? "spanCellPago"
                        : ""
                    }
                  >
                    {params.row.nome}
                  </span>
                )}

                <Tooltip title="Ver orçamento">
                  <IconButton
                    onClick={handleOpenModalProcedimentos.bind(
                      null,
                      params.row.orcamento,
                    )}
                  >
                    <ErrorIcon className="muiIconVerOrcamento" />
                  </IconButton>
                </Tooltip>
              </div>
            )}

            {params.row.tipo === "entrada" && (
              <div
                className={
                  "link-cliente-receita " + params.row.entradaRecebida &&
                  params.row.dataPagamento
                    ? "spanCellPago"
                    : !params.row.entradaRecebida &&
                        moment().isAfter(
                          moment(params.row.dataLimitePagamento),
                          "day",
                        )
                      ? "spanCellAtraso"
                      : ""
                }
              >
                {/* A pastilha estava só no ramo das parcelas (`tipo ===
                    "receita"`). As entradas caem neste outro ramo e ficavam
                    sem indicação nenhuma da unidade, apesar de a linha já a
                    trazer. A da caixa serve de recurso para os recebimentos
                    anteriores ao carimbo. */}
                <BadgeUnidade
                  estabelecimento={
                    params.row.estabelecimento ||
                    params.row.caixa?.estabelecimento
                  }
                  prefixo="Registada em"
                />{" "}
                {/* «Só consulta» sem ressalvas, ao contrário do orçamento aqui
                    ao lado, que diz «venda de outra unidade» porque lá o
                    dinheiro ainda se pode mexer. Numa entrada não: ela É o
                    movimento, e fora da sua unidade não se recebe, não se
                    edita, não se emite nem se cancela. */}
                <SeloSoConsulta
                  estabelecimento={
                    params.row.estabelecimento ||
                    params.row.caixa?.estabelecimento
                  }
                />{" "}
                Entrada - {params.row.descricao}
              </div>
            )}
          </>
        );
      },
    },
    {
      field: "estado",
      headerName: "Pagamento",
      flex: 2,
      renderCell: (params) => {
        return (
          <>
            {params.row.tipo === "receita" && (
              <div className="cellDebitoEstado">
                {params.row.orcamento.desconto ===
                  params.row.orcamento.subtotal -
                    (params.row.orcamento.majoracao || 0) && (
                  <span className="debitos__isento">Isenção</span>
                )}

                {params.row.orcamento.desconto !==
                  params.row.orcamento.subtotal -
                    (params.row.orcamento.majoracao || 0) && (
                  <span
                    className={`debitos__container__estado ${
                      params.row.estado === "Em atraso" &&
                      params.row.status !== "CANCELADA"
                        ? "debitos__container__estado--atraso"
                        : params.row.estado === "Pago" &&
                            params.row.status !== "CANCELADA"
                          ? "debitos__container__estado--pago"
                          : ""
                    }`}
                  >
                    {params.row.metodoPagamento
                      ? params.row.metodoPagamento
                      : params.row.estado}
                  </span>
                )}
              </div>
            )}
            {params.row.tipo === "entrada" && (
              <div className="cellDebitoEstado">
                <span
                  className={
                    "debitos__container__estado debitos__container__estado--pago"
                  }
                >
                  {params.row.metodoPagamento}
                </span>
              </div>
            )}
          </>
        );
      },
    },
    {
      field: "valor",
      headerName: "Valor",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {params.row.tipo === "receita" && (
              <div className="cellAction">
                {params.row.orcamento.desconto !==
                  params.row.orcamento.subtotal -
                    (params.row.orcamento.majoracao || 0) && (
                  <span
                    className={`debitos__container__valor ${
                      params.row.estado === "Em atraso" &&
                      params.row.status !== "CANCELADA"
                        ? "debitos__container__valor--atraso"
                        : params.row.estado === "Pago" &&
                            params.row.status !== "CANCELADA"
                          ? "debitos__container__valor--pago"
                          : ""
                    }`}
                  >
                    {params.row.valor}
                  </span>
                )}
              </div>
            )}

            {params.row.tipo === "entrada" && (
              <span
                className={
                  params.row.entradaRecebida && params.row.dataPagamento
                    ? "spanCellPago"
                    : !params.row.entradaRecebida &&
                        moment().isAfter(
                          moment(params.row.dataLimitePagamento),
                          "day",
                        )
                      ? "spanCellAtraso"
                      : ""
                }
                style={{ marginLeft: "auto" }}
              >
                {params.row.valor}
              </span>
            )}
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Estado",
      flex: 1.5,
      renderCell: (params) => {
        return (
          <div className="cellDebitoStatus">
            {params.row.estado === "Pago" && (
              <span
                className={
                  params.row.orcamento?.desconto ===
                  params.row.orcamento?.subtotal -
                    (params.row.orcamento.majoracao || 0)
                    ? "debitos__container__receber debitos__container__receber--isento"
                    : "debitos__container__receber debitos__container__receber--pago"
                }
              >
                <Tooltip
                  title={
                    params.row.orcamento?.desconto ===
                    params.row.orcamento?.subtotal -
                      (params.row.orcamento.majoracao || 0)
                      ? "Parcela Isenta de Pagamento"
                      : `Parcela recebida ${
                          params.row.recebidoPor
                            ? "por " + params.row.recebidoPor
                            : ""
                        }${
                          params.row.dataRecebimento
                            ? " aos " + params.row.dataRecebimento
                            : ""
                        }`
                  }
                >
                  <CheckCircleIcon sx={{ cursor: "help" }} />
                </Tooltip>
              </span>
            )}

            {params.row.documentoEletronico?.succeeded === true &&
              !params.row.faturaEReciboEletronicos?.fte && (
                <span
                  className={
                    params.row.documentoEletronico?.emitidoEmContingencia
                      ? "debitos__container__receber debitos__container__receber--contingencia"
                      : params.row.documentoEletronico?.tipoDocumento === "FTE"
                        ? "debitos__container__receber debitos__container__receber--fte"
                        : "debitos__container__receber debitos__container__receber--pago"
                  }
                >
                  <Tooltip
                    title={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {/* NOVO: Texto diferente para contingência */}
                        {params.row.documentoEletronico
                          ?.emitidoEmContingencia ? (
                          <>
                            {`⚠️ ${params.row.documentoEletronico?.tipoDocumento} emitido em CONTINGÊNCIA`}
                            <br />
                            {`Emitido offline em: ${
                              params.row.dataEmissao || "N/A"
                            }`}
                            {params.row.documentoEletronico
                              ?.motivoContingencia && (
                              <>
                                <br />
                                {`Motivo: ${params.row.documentoEletronico.motivoContingencia}`}
                              </>
                            )}
                            <br />
                            <br />
                            {`Documento aguardando transmissão para E-fatura.`}
                          </>
                        ) : (
                          // Texto normal para documentos online
                          <>
                            {`${
                              params.row.documentoEletronico?.tipoDocumento +
                              " " +
                              (params.row.documentoEletronico?.nrDocumento ||
                                "")
                            } emitido ${
                              params.row.emitidoPor
                                ? `por ${params.row.emitidoPor}`
                                : ""
                            }${
                              params.row.dataEmissao
                                ? ` aos ${params.row.dataEmissao}`
                                : ""
                            }.`}
                            {params.row?.cancelamentosDocumentosEletronicos
                              ?.length > 0 && (
                              <>
                                <br />
                                {`${params.row.cancelamentosDocumentosEletronicos.length} cancelamentos efetuados.`}
                                {params.row.cancelamentosDocumentosEletronicos.map(
                                  (c, index) => (
                                    <React.Fragment key={index}>
                                      <br />
                                      {c.documento.entryName.split(".")[0]}
                                    </React.Fragment>
                                  ),
                                )}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    }
                  >
                    <ArticleOutlinedIcon sx={{ cursor: "help" }} />
                  </Tooltip>
                </span>
              )}

            {params.row.nrRecibo && (
              <span className="debitos__container__receber debitos__container__receber--reciboInterno">
                <Tooltip title="Recibo Interno">
                  <ArticleOutlinedIcon sx={{ cursor: "help" }} />
                </Tooltip>
              </span>
            )}

            {params.row.documentoEletronico?.succeeded === false && (
              <span className="debitos__container__receber debitos__container__receber--atraso">
                <Tooltip
                  title={
                    <div style={{ whiteSpace: "pre-line" }}>
                      {`${params.row.documentoEletronico?.tipoDocumento} com erro.`}
                      {params.row?.documentoEletronico?.messages?.length >
                        0 && (
                        <>
                          {params.row.documentoEletronico.messages.map(
                            (m, index) => (
                              <React.Fragment key={index}>
                                <br />
                                <br />
                                {m.description}
                              </React.Fragment>
                            ),
                          )}
                        </>
                      )}
                    </div>
                  }
                >
                  <ArticleOutlinedIcon sx={{ cursor: "help" }} />
                </Tooltip>
              </span>
            )}

            {params.row.cancelamentosDocumentosEletronicos?.length > 0 &&
              params.row.cancelamentosDocumentosEletronicos[
                params.row.cancelamentosDocumentosEletronicos?.length - 1
              ]?.documentoCancelamento?.succeeded === false && (
                <span className="debitos__container__receber debitos__container__receber--atraso">
                  <Tooltip
                    title={
                      <React.Fragment>
                        {
                          params.row.cancelamentosDocumentosEletronicos[
                            params.row.cancelamentosDocumentosEletronicos
                              ?.length - 1
                          ]?.documentoCancelamento?.tipoDocumento
                        }{" "}
                        com erro:
                        <br />
                        {params.row.cancelamentosDocumentosEletronicos[
                          params.row.cancelamentosDocumentosEletronicos.length -
                            1
                        ].documentoCancelamento.messages.map((m, index) => (
                          <React.Fragment key={index}>
                            {index > 0 && (
                              <>
                                <br />
                                <br />
                              </>
                            )}
                            {m.description}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    }
                  >
                    <ArticleOutlinedIcon sx={{ cursor: "help" }} />
                  </Tooltip>
                </span>
              )}

            {/* FTE emitida */}
            {params.row.tipo === "receita" &&
              params.row.faturaEReciboEletronicos?.fte?.succeeded === true && (
                <span className="debitos__container__receber debitos__container__receber--fte">
                  <Tooltip
                    title={
                      params.row.faturaEReciboEletronicos.fte
                        ?.emitidoEmContingencia ? (
                        <div style={{ whiteSpace: "pre-line" }}>
                          {`⚠️ FTE ${
                            params.row.faturaEReciboEletronicos.fte
                              ?.nrDocumento || ""
                          } emitida em CONTINGÊNCIA`}
                          <br />
                          {`Emitido offline em: ${params.row.dataEmissaoFte || "N/A"}`}
                          {params.row.faturaEReciboEletronicos.fte
                            ?.motivoContingencia && (
                            <>
                              <br />
                              {`Motivo: ${params.row.faturaEReciboEletronicos.fte.motivoContingencia}`}
                            </>
                          )}
                          <br />
                          <br />
                          {`Documento aguardando transmissão para E-fatura.`}
                        </div>
                      ) : (
                        `FTE ${
                          params.row.faturaEReciboEletronicos.fte
                            ?.nrDocumento || ""
                        } emitida${
                          params.row.fteEmitidoPor
                            ? ` por ${params.row.fteEmitidoPor}`
                            : ""
                        }${
                          params.row.dataEmissaoFte
                            ? ` aos ${params.row.dataEmissaoFte}`
                            : ""
                        }.`
                      )
                    }
                  >
                    <ArticleOutlinedIcon sx={{ cursor: "help" }} />
                  </Tooltip>
                </span>
              )}

            {/* FTE com erro */}
            {params.row.tipo === "receita" &&
              params.row.faturaEReciboEletronicos?.fte?.succeeded === false && (
                <span className="debitos__container__receber debitos__container__receber--atraso">
                  <Tooltip
                    title={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {`FTE com erro.`}
                        {params.row?.faturaEReciboEletronicos?.fte?.messages
                          ?.length > 0 && (
                          <>
                            {params.row.faturaEReciboEletronicos.fte.messages.map(
                              (m, index) => (
                                <React.Fragment key={index}>
                                  <br />
                                  <br />
                                  {m.description}
                                </React.Fragment>
                              ),
                            )}
                          </>
                        )}
                      </div>
                    }
                  >
                    <ArticleOutlinedIcon sx={{ cursor: "help" }} />
                  </Tooltip>
                </span>
              )}

            {/* RCE emitido */}
            {/* RCE emitido */}
            {params.row.tipo === "receita" &&
              params.row.faturaEReciboEletronicos?.rce?.succeeded === true && (
                <span
                  className={
                    params.row.faturaEReciboEletronicos.rce
                      ?.emitidoEmContingencia
                      ? "debitos__container__receber debitos__container__receber--contingencia"
                      : "debitos__container__receber debitos__container__receber--rce"
                  }
                >
                  <Tooltip
                    title={
                      params.row.faturaEReciboEletronicos.rce
                        ?.emitidoEmContingencia ? (
                        <div style={{ whiteSpace: "pre-line" }}>
                          {`⚠️ RCE ${
                            params.row.faturaEReciboEletronicos.rce
                              ?.nrDocumento || ""
                          } emitido em CONTINGÊNCIA`}
                          <br />
                          {`Emitido offline em: ${params.row.dataEmissaoRce || "N/A"}`}
                          {params.row.faturaEReciboEletronicos.rce
                            ?.motivoContingencia && (
                            <>
                              <br />
                              {`Motivo: ${params.row.faturaEReciboEletronicos.rce.motivoContingencia}`}
                            </>
                          )}
                          <br />
                          <br />
                          {`Documento aguardando transmissão para E-fatura.`}
                        </div>
                      ) : (
                        `RCE ${
                          params.row.faturaEReciboEletronicos.rce
                            ?.nrDocumento || ""
                        } emitido${
                          params.row.rceEmitidoPor
                            ? ` por ${params.row.rceEmitidoPor}`
                            : ""
                        }${
                          params.row.dataEmissaoRce
                            ? ` aos ${params.row.dataEmissaoRce}`
                            : ""
                        }.`
                      )
                    }
                  >
                    <ArticleOutlinedIcon sx={{ cursor: "help" }} />
                  </Tooltip>
                </span>
              )}
            {/* RCE com erro */}
            {params.row.tipo === "receita" &&
              params.row.faturaEReciboEletronicos?.rce?.succeeded === false && (
                <span className="debitos__container__receber debitos__container__receber--atraso">
                  <Tooltip
                    title={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {`RCE com erro.`}
                        {params.row?.faturaEReciboEletronicos?.rce?.messages
                          ?.length > 0 && (
                          <>
                            {params.row.faturaEReciboEletronicos.rce.messages.map(
                              (m, index) => (
                                <React.Fragment key={index}>
                                  <br />
                                  <br />
                                  {m.description}
                                </React.Fragment>
                              ),
                            )}
                          </>
                        )}
                      </div>
                    }
                  >
                    <ArticleOutlinedIcon sx={{ cursor: "help" }} />
                  </Tooltip>
                </span>
              )}

            {/* Entradas */}
            {params.row.tipo === "entrada" && params.row.entradaRecebida && (
              <span className="debitos__container__receber debitos__container__receber--pago">
                <Tooltip
                  title={`Entrada recebida ${
                    params.row.recebidoPor
                      ? `por ${params.row.recebidoPor}`
                      : ""
                  }${
                    params.row.dataRecebimento
                      ? " aos " + params.row.dataRecebimento
                      : ""
                  }`}
                >
                  <CheckCircleIcon sx={{ cursor: "help" }} />
                </Tooltip>
              </span>
            )}

            {/* Caso houveram cancelamentos, apresentar a mensagem*/}
            {params.row.cancelamentosDocumentosEletronicos?.filter(
              (can) => can.documentoCancelamento?.succeeded === true,
            ).length > 0 && (
              <span className="debitos__container__receber debitos__container__receber--atraso">
                <Tooltip
                  title={
                    <React.Fragment>
                      Essa{" "}
                      {params.row.tipo === "entrada" ? "entrada" : "parcela"}{" "}
                      tem {params.row.cancelamentosDocumentosEletronicos.length}{" "}
                      {params.row.cancelamentosDocumentosEletronicos.length > 1
                        ? "cancelamentos"
                        : "cancelamento"}
                      :
                      <br />
                      <br />
                      {params.row.cancelamentosDocumentosEletronicos.map(
                        (d, index) => (
                          <React.Fragment key={index}>
                            {index > 0 && (
                              <>
                                <br />
                              </>
                            )}
                            {"* " +
                              d.documentoCancelamento.entryName.split(
                                ".xml",
                              )[0]}
                          </React.Fragment>
                        ),
                      )}
                    </React.Fragment>
                  }
                >
                  <CancelIcon sx={{ cursor: "help" }} />
                </Tooltip>
              </span>
            )}
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Ações",
      flex: 1.5,
      renderCell: (params) => {
        /* Este menu não verifica a unidade, e é deliberado.
         *
         * Tudo o que aqui está toca no DINHEIRO — receber, cancelar
         * recebimento, emitir e anular os documentos desse recebimento — e a
         * receita é de quem recebe. Um paciente que se desloca ao outro local
         * para terminar o tratamento antes de viajar tem de poder pagar lá. É
         * raro, mas é legítimo.
         *
         * O que continua limitado à unidade que orçamentou é a VENDA: editar,
         * aprovar, substituir, descontos, credencial e majoração. Isso vive no
         * botão "Ações" do cabeçalho da conta, que verifica a unidade.
         *
         * Regra confirmada com a dona da clínica em 2026-08-15. */

        /* A exceção é FISCAL. Se já existe fatura, tudo o que se lhe refere —
         * receber (que emite o recibo), anular, cancelar o recebimento — tem de
         * sair pelo LED de quem a emitiu. Nesses casos a opção fica acinzentada
         * com a razão, em vez de desaparecer: quem procura "cancelar
         * recebimento" e não o encontra pensa que é avaria. */
        const docDaLinha = params.row.documentoEletronico;
        const docBloqueado = !podeMexerNoDocumento(docDaLinha, auth);
        const motivoDoc = docBloqueado
          ? motivoBloqueioDocumento(docDaLinha)
          : undefined;

        /* Uma FRE precisa de NIF válido; sem ele o documento a emitir é uma
           TVE. Os dois genéricos não servem — o servidor recusa-os com
           «Nifs 000000000 ou 999999999 não são válidos para FREs».

           Isto vive aqui, e não repetido nas duas opções, porque era
           exatamente essa a origem do defeito: a TVE verificava o NIF e a FRE
           não, por isso com NIF inválido apareciam as duas e a FRE rebentava
           na emissão. Encontrado nos testes da fase 1, a 2026-08-19. */
        const nifInvalido =
          !clienteData?.nif ||
          clienteData.nif === "000000000" ||
          clienteData.nif === "999999999";

        let content;
        if (params.row.tipo === "receita") {
          /* Numa parcela há DUAS unidades, e a regra não é a mesma para as duas.
           *
           *   A VENDA é da unidade que orçamentou. Editar o orçamento, aprovar,
           *   substituir — isso decide-se lá, e já está tratado no cabeçalho da
           *   conta, com o selo «venda de outra unidade».
           *
           *   O DINHEIRO é da unidade que RECEBEU, e pode ser a outra: um
           *   paciente que estava de passagem paga onde está. Cancelar esse
           *   recebimento, emitir o documento fiscal dele ou passar o recibo
           *   interno são atos de quem ficou com o dinheiro — e o documento tem
           *   de sair sob o LED dessa unidade, não sob o desta.
           *
           * É por isso que se compara com a unidade da PARCELA, e não com a do
           * orçamento. A caixa serve de recurso para os recebimentos anteriores
           * ao carimbo. */
          const doMeuBalcao =
            !params.row.parcelaPaga ||
            podeAlterarRegisto(
              params.row.estabelecimento || params.row.caixa?.estabelecimento,
              auth,
            );

          if (
            params.row.orcamento.desconto ===
              params.row.orcamento.subtotal -
                (params.row.orcamento.majoracao || 0) &&
            !params.row.motivoEncerramento
          ) {
            return null;
          } else if (params.row.parcelaPaga) {
            content = (
              <>
                <div
                  className="popOverMenu--option"
                  onClick={verReceitaHandler.bind(
                    null,
                    params.row.id,
                    params.row.contaId,
                  )}
                >
                  <span>Ver</span>
                  <RemoveRedEyeIcon className="popOverMenu--option__icon" />
                </div>

                {/* EDITAR uma parcela JÁ PAGA: só a caixa, a descrição e a
                    observação, com motivo — ver `ModalCorrigirCaixa`. */}
                {podeCorrigirCaixa(auth) && doMeuBalcao && (
                  <div
                    className="popOverMenu--option"
                    onClick={() => setCorrigirCaixa({ tipo: "parcela", id: params.row.id })}
                  >
                    <span>Editar</span>
                    <EditIcon className="popOverMenu--option__icon" />
                  </div>
                )}

                {/*PDF FRE - apenas se o documento fiscal enviado for bem sucedido  */}
                {auth.perm.includes("u-parc") &&
                  params.row.documentoEletronico?.succeeded && (
                    <div
                      className="popOverMenu--option"
                      onClick={gerarPdfFaturaEletronicaHandler.bind(
                        null,
                        params.row.id,
                        params.row.contaId,
                      )}
                    >
                      <span>
                        Gerar PDF {params.row.documentoEletronico.tipoDocumento}
                      </span>
                      <ArticleOutlinedIcon
                        className="popOverMenu--option__icon"
                        sx={{ color: "green" }}
                      />
                    </div>
                  )}

                {/* PDF RCE - quando existe RCE bem-sucedido */}
                {auth.perm.includes("u-parc") &&
                  params.row.faturaEReciboEletronicos?.rce?.succeeded && (
                    <div
                      className="popOverMenu--option"
                      onClick={gerarPdfRceParcelaHandler.bind(
                        null,
                        params.row.id,
                        params.row.contaId,
                      )}
                    >
                      <span>Gerar PDF RCE</span>
                      <ArticleOutlinedIcon
                        className="popOverMenu--option__icon"
                        sx={{ color: "green" }}
                      />
                    </div>
                  )}

                {/* EMITIR FRE - se a parcela nao esta associada a um documento fiscal e se o ultimo cancelamento não tiver erro */}
                {auth.perm.includes("u-parc") &&
                  doMeuBalcao &&
                  !params.row.motivoEncerramento &&
                  (!params.row.documentoEletronico ||
                    params.row.documentoEletronico?.succeeded === false) &&
                  !params.row.nrRecibo &&
                  (params.row.cancelamentosDocumentosEletronicos?.length ===
                    0 ||
                    (params.row.cancelamentosDocumentosEletronicos?.length >
                      0 &&
                      params.row.cancelamentosDocumentosEletronicos[
                        params.row.cancelamentosDocumentosEletronicos?.length -
                          1
                      ]?.documentoCancelamento?.succeeded === true)) &&
                  // Sem NIF válido não há FRE — o documento é uma TVE.
                  !nifInvalido && (
                    <Popconfirm
                      title="Fatura Recibo Eletrónico"
                      description={`Pretende emitir a FRE${
                        modoContingenciaAtivo ? " em CONTINGÊNCIA" : ""
                      }?`}
                      icon={<ErrorIcon style={{ color: "red" }} />}
                      okText="Sim"
                      cancelText="Não"
                      onConfirm={handleBeforeEmitirDocEletronico.bind(
                        null,
                        params.row.id,
                        params.row.contaId,
                        "FRE",
                      )}
                    >
                      <div className="popOverMenu--option">
                        Emitir FRE{modoContingenciaAtivo && " (Contingência)"}
                        <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                      </div>
                    </Popconfirm>
                  )}

                {/* EMITIR TVE - se a parcela nao esta associada a um documento fiscal e se o ultimo cancelamento não tiver erro */}
                {auth.perm.includes("u-parc") &&
                  doMeuBalcao &&
                  !params.row.motivoEncerramento &&
                  (!params.row.documentoEletronico ||
                    params.row.documentoEletronico?.succeeded === false) &&
                  !params.row.nrRecibo &&
                  (params.row.cancelamentosDocumentosEletronicos?.length ===
                    0 ||
                    (params.row.cancelamentosDocumentosEletronicos?.length >
                      0 &&
                      params.row.cancelamentosDocumentosEletronicos[
                        params.row.cancelamentosDocumentosEletronicos?.length -
                          1
                      ]?.documentoCancelamento?.succeeded === true)) &&
                  nifInvalido && (
                    <Popconfirm
                      title="Talão de Venda Eletrónico"
                      description={`Pretende emitir a TVE${
                        modoContingenciaAtivo ? " em CONTINGÊNCIA" : ""
                      }?`}
                      icon={<ErrorIcon style={{ color: "red" }} />}
                      okText="Sim"
                      cancelText="Não"
                      onConfirm={handleBeforeEmitirDocEletronico.bind(
                        null,
                        params.row.id,
                        params.row.contaId,
                        "TVE",
                      )}
                    >
                      <div className="popOverMenu--option">
                        Emitir TVE{modoContingenciaAtivo && " (Contingência)"}
                        <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                      </div>
                    </Popconfirm>
                  )}

                {/* EMITIR RCE - após pagamento, quando existe FTE bem-sucedida.
                    O RCE refere-se a essa FTE e tem de sair pelo MESMO LED, por
                    isso obedece ao `docBloqueado` como o cancelamento e a NCE. */}
                {auth.perm.includes("u-parc") &&
                  doMeuBalcao &&
                  !params.row.motivoEncerramento &&
                  params.row.documentoEletronico?.succeeded === true &&
                  params.row.documentoEletronico?.tipoDocumento === "FTE" &&
                  (!params.row.faturaEReciboEletronicos?.rce ||
                    params.row.faturaEReciboEletronicos?.rce?.succeeded ===
                      false) &&
                  (docBloqueado ? (
                    <div
                      className="popOverMenu--option popOverMenu--option--desativada"
                      title={motivoDoc}
                    >
                      {params.row.faturaEReciboEletronicos?.rce?.succeeded ===
                      false
                        ? "Re-emitir RCE"
                        : "Emitir RCE"}
                      <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                    </div>
                  ) : (
                    <Popconfirm
                      title="Recibo de Crédito Eletrónico"
                      description="Pretende emitir um RCE?"
                      icon={<ErrorIcon style={{ color: "red" }} />}
                      okText="Sim"
                      cancelText="Não"
                      onConfirm={emitirRCEHandler.bind(
                        null,
                        params.row.id,
                        params.row.contaId,
                      )}
                    >
                      <div className="popOverMenu--option">
                        {params.row.faturaEReciboEletronicos?.rce?.succeeded ===
                        false
                          ? "Re-emitir RCE"
                          : "Emitir RCE"}
                        <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                      </div>
                    </Popconfirm>
                  ))}

                {/* RECIBO INTERNO - Parcela paga (no If lá acima), com dinheiro, orcamento particular, sem documentoEletronico com ou sem erro e sem cancelamento com erro */}
                {auth.perm.includes("u-parc") &&
                  doMeuBalcao &&
                  !params.row.motivoEncerramento &&
                  !params.row.nrRecibo &&
                  (reciboSemRestricoes ||
                    ((params.row.orcamento.beneficio === "Particular" ||
                      params.row.orcamento.orcamentoMisto) &&
                      params.row.metodoPagamento === "Dinheiro")) &&
                  (!params.row.documentoEletronico ||
                    params.row.documentoEletronico?.succeeded === false) && (
                    //   &&
                    // (params.row.cancelamentosDocumentosEletronicos?.length ===
                    //   0 ||
                    //   (params.row.cancelamentosDocumentosEletronicos?.length >
                    //     0 &&
                    //     params.row.cancelamentosDocumentosEletronicos[
                    //       params.row.cancelamentosDocumentosEletronicos?.length -
                    //         1
                    //     ]?.documentoCancelamento?.succeeded === false))

                    <Popconfirm
                      title="Recibo Interno"
                      description={`Pretende emitir um recibo Interno?`}
                      icon={<ErrorIcon style={{ color: "red" }} />}
                      okText="Sim"
                      cancelText="Não"
                      onConfirm={beforeGerarReciboHandler.bind(
                        null,
                        params.row.id,
                        params.row.contaId,
                      )}
                    >
                      <div className="popOverMenu--option">
                        Gerar Recibo Interno
                        <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                      </div>
                    </Popconfirm>
                  )}

                {auth.perm.includes("u-parc") && params.row.nrRecibo && (
                  <div
                    className="popOverMenu--option"
                    onClick={beforeGerarReciboHandler.bind(
                      null,
                      params.row.id,
                      params.row.contaId,
                    )}
                  >
                    <span>Gerar PDF Recibo Interno</span>
                    <ArticleOutlinedIcon
                      className="popOverMenu--option__icon"
                      sx={{ color: "gray" }}
                    />
                  </div>
                )}

                {auth.perm.includes("u-parc") &&
                  doMeuBalcao &&
                  params.row.nrRecibo &&
                  !params.row.motivoEncerramento && (
                    <Popconfirm
                      title="Anular Recibo Interno"
                      description="Tem a certeza que pretende anular o recibo interno desta parcela?"
                      icon={<ErrorIcon style={{ color: "red" }} />}
                      okText="Sim"
                      cancelText="Não"
                      onConfirm={handleAnularReciboInterno.bind(
                        null,
                        params.row.id,
                        params.row.contaId,
                      )}
                    >
                      <div className="popOverMenu--option">
                        <span>Anular Recibo Interno</span>
                        <CancelIcon
                          className="popOverMenu--option__icon"
                          sx={{ color: "crimson" }}
                        />
                      </div>
                    </Popconfirm>
                  )}

                {auth.perm.includes("u-parc") &&
                  params.row?.cancelamentosDocumentosEletronicos?.length > 0 &&
                  params.row?.cancelamentosDocumentosEletronicos
                    .filter(
                      (can) => can.documentoCancelamento?.succeeded === true,
                    )
                    .map((can, index) => (
                      <div
                        className="popOverMenu--option"
                        onClick={gerarPdfFaturaEletronicaHandler.bind(
                          null,
                          params.row.id,
                          params.row.contaId,
                          "NCE",
                          can,
                        )}
                        key={"pdfNce" + index}
                      >
                        <span>
                          Gerar PDF NCE {can.documentoCancelamento.nrDocumento}
                        </span>
                        <ArticleOutlinedIcon
                          className="popOverMenu--option__icon"
                          sx={{ color: "crimson" }}
                        />
                      </div>
                    ))}

                {/* Exatamento como o anterior. Caso exista documentos eletronicos ou cancelamentos, são verificados como o anterior */}
                {auth.perm.includes("u-parc") &&
                  doMeuBalcao &&
                  params.row.parcelaPaga &&
                  !params.row.motivoEncerramento &&
                  (docBloqueado ? (
                    <div
                      className="popOverMenu--option popOverMenu--option--desativada"
                      title={motivoDoc}
                    >
                      <span>Cancelar recebimento</span>
                      <SettingsBackupRestoreIcon className="popOverMenu--option__icon" />
                    </div>
                  ) : (
                    <Popconfirm
                      title="Cancelar Recebimento"
                      description={`Pretende cancelar o recebimento da ${
                        params.row.nome
                      } ${
                        params.row.documentoEletronico?.succeeded === true &&
                        params.row.documentoEletronico?.tipoDocumento !== "FTE"
                          ? "com a emissão de uma Nota de Crédito?"
                          : ""
                      }`}
                      icon={<ErrorIcon style={{ color: "red" }} />}
                      okText="Sim"
                      cancelText="Não"
                      onConfirm={beforeCancelarRecebimento.bind(
                        null,
                        params.row.id,
                        params.row.contaId,
                      )}
                    >
                      <div className="popOverMenu--option">
                        <span>Cancelar recebimento</span>
                        <SettingsBackupRestoreIcon className="popOverMenu--option__icon" />
                      </div>
                    </Popconfirm>
                  ))}
              </>
            );
          } else if (
            // Só dispara quando o ÚLTIMO cancelamento falhou — caso em que o
            // único caminho é o utilizador ver os PDFs e re-tentar manualmente
            // o fluxo que falhou. Cancelamentos bem-sucedidos caem nos ramos
            // abaixo, que continuam a oferecer "Emitir FTE" e ainda mostram
            // os PDFs das NCEs antigas.
            auth.perm.includes("u-parc") &&
            params.row?.cancelamentosDocumentosEletronicos?.length > 0 &&
            params.row.cancelamentosDocumentosEletronicos[
              params.row.cancelamentosDocumentosEletronicos.length - 1
            ]?.documentoCancelamento?.succeeded === false
          ) {
            content = (
              <>
                {params.row.cancelamentosDocumentosEletronicos
                  .filter(
                    (can) => can.documentoCancelamento?.succeeded === true,
                  )
                  .map((can, index) => (
                    <div
                      className="popOverMenu--option"
                      onClick={gerarPdfFaturaEletronicaHandler.bind(
                        null,
                        params.row.id,
                        params.row.contaId,
                        "NCE",
                        can,
                      )}
                      key={"pdfNce" + index}
                    >
                      <span>
                        Gerar PDF NCE {can.documentoCancelamento.nrDocumento}
                      </span>
                      <ArticleOutlinedIcon
                        className="popOverMenu--option__icon"
                        sx={{ color: "crimson" }}
                      />
                    </div>
                  ))}
              </>
            );
          } else if (
            // NOVO: parcela não paga, COM FTE bem-sucedida — opções para
            // gerar PDF e anular a FTE com NCE.
            auth.perm.includes("u-parc") &&
            !params.row.motivoEncerramento &&
            params.row.documentoEletronico?.succeeded === true &&
            params.row.documentoEletronico?.tipoDocumento === "FTE" &&
            !params.row.faturaEReciboEletronicos?.rce?.succeeded
          ) {
            content = (
              <>
                {/* Gerar PDF FTE */}
                <div
                  className="popOverMenu--option"
                  onClick={gerarPdfFaturaEletronicaHandler.bind(
                    null,
                    params.row.id,
                    params.row.contaId,
                  )}
                >
                  <span>Gerar PDF FTE</span>
                  <ArticleOutlinedIcon
                    className="popOverMenu--option__icon"
                    sx={{ color: "#652d85" }}
                  />
                </div>

                {/* Anular FTE com NCE */}
                {docBloqueado ? (
                  <div
                    className="popOverMenu--option popOverMenu--option--desativada"
                    title={motivoDoc}
                  >
                    <span>Anular Fatura</span>
                    <ArticleOutlinedIcon
                      className="popOverMenu--option__icon"
                      sx={{ color: "crimson" }}
                    />
                  </div>
                ) : (
                  <Popconfirm
                    title="Nota de Crédito - NCE"
                    description="Pretende cancelar a FTE com a emissão de uma nota de crédito?"
                    icon={<ErrorIcon style={{ color: "red" }} />}
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={handleBeforeNCEParcela.bind(
                      null,
                      params.row.id,
                      params.row.contaId,
                    )}
                  >
                    <div className="popOverMenu--option">
                      <span>Anular Fatura</span>
                      <ArticleOutlinedIcon
                        className="popOverMenu--option__icon"
                        sx={{ color: "crimson" }}
                      />
                    </div>
                  </Popconfirm>
                )}

                {/* NCEs existentes (PDFs) */}
                {params.row?.cancelamentosDocumentosEletronicos?.length > 0 &&
                  params.row.cancelamentosDocumentosEletronicos
                    .filter(
                      (can) => can.documentoCancelamento?.succeeded === true,
                    )
                    .map((can, index) => (
                      <div
                        className="popOverMenu--option"
                        onClick={gerarPdfFaturaEletronicaHandler.bind(
                          null,
                          params.row.id,
                          params.row.contaId,
                          "NCE",
                          can,
                        )}
                        key={"pdfNce" + index}
                      >
                        <span>
                          Gerar PDF NCE {can.documentoCancelamento.nrDocumento}
                        </span>
                        <ArticleOutlinedIcon
                          className="popOverMenu--option__icon"
                          sx={{ color: "crimson" }}
                        />
                      </div>
                    ))}
              </>
            );
          } else if (
            auth.perm.includes("u-parc") &&
            !params.row.motivoEncerramento &&
            !params.row.documentoEletronico?.succeeded &&
            !params.row.faturaEReciboEletronicos?.rce?.succeeded
          ) {
            content = (
              <>
                <Popconfirm
                  title="Fatura de Transação Eletrónica"
                  description="Pretende emitir uma FTE?"
                  icon={<ErrorIcon style={{ color: "red" }} />}
                  okText="Sim"
                  cancelText="Não"
                  onConfirm={emitirFTEHandler.bind(
                    null,
                    params.row.id,
                    params.row.contaId,
                  )}
                >
                  <div className="popOverMenu--option">
                    {params.row.faturaEReciboEletronicos?.fte?.succeeded ===
                    false
                      ? "Re-emitir FTE"
                      : "Emitir FTE"}
                    <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                  </div>
                </Popconfirm>

                {/* PDFs de NCEs anteriores (caso parcela já tenha sido anulada antes) */}
                {params.row?.cancelamentosDocumentosEletronicos?.length > 0 &&
                  params.row.cancelamentosDocumentosEletronicos
                    .filter(
                      (can) => can.documentoCancelamento?.succeeded === true,
                    )
                    .map((can, index) => (
                      <div
                        className="popOverMenu--option"
                        onClick={gerarPdfFaturaEletronicaHandler.bind(
                          null,
                          params.row.id,
                          params.row.contaId,
                          "NCE",
                          can,
                        )}
                        key={"pdfNcePos" + index}
                      >
                        <span>
                          Gerar PDF NCE {can.documentoCancelamento.nrDocumento}
                        </span>
                        <ArticleOutlinedIcon
                          className="popOverMenu--option__icon"
                          sx={{ color: "crimson" }}
                        />
                      </div>
                    ))}
              </>
            );
          }
        }
        if (params.row.tipo === "entrada") {
          /* Uma entrada de outra unidade é só de consulta.
           *
           * O dinheiro entrou na caixa do outro balcão: cancelar o
           * recebimento, gerar o recibo interno ou emitir um documento daqui
           * mexeria no fecho de uma unidade a partir da outra — e o documento
           * sairia sob o LED errado. O servidor já recusa as três; sem isto, a
           * pessoa carrega e recebe um erro em vez de perceber porquê.
           *
           * `Ver`, `Gerar PDF` e `Baixar comprovativo` ficam: são leitura. */
          const daMinhaUnidade = podeAlterarRegisto(
            params.row.estabelecimento || params.row.caixa?.estabelecimento,
            auth,
          );
          content = (
            <div className="dots__menu__popup">
              {/* VER ENTRADA */}
              {auth.perm.includes("r-ent") && (
                <div
                  className="popOverMenu--option"
                  onClick={verEntradaHandler.bind(null, params.row.id)}
                >
                  <span>Ver</span>
                  <RemoveRedEyeIcon className="popOverMenu--option__icon" />
                </div>
              )}
              {/* EDITAR uma entrada JÁ RECEBIDA: só a caixa, a descrição e a
                  observação, com motivo — ver `ModalCorrigirCaixa`. */}
              {params.row.entradaRecebida &&
                daMinhaUnidade &&
                podeCorrigirCaixa(auth) && (
                  <div
                    className="popOverMenu--option"
                    onClick={() => setCorrigirCaixa({ tipo: "entrada", id: params.row.id })}
                  >
                    <span>Editar</span>
                    <EditIcon className="popOverMenu--option__icon" />
                  </div>
                )}

              {/* EDITAR ENTRADA - apenas entradas que não possuem documento fiscal, cujo envio resultou em erro ou que nao estao pagas, não pode editar um documento com um envio de nce com erro*/}
              {auth.perm.includes("u-ent") &&
                daMinhaUnidade &&
                (!params.row.documentoEletronico ||
                  params.row.documentoEletronico?.succeeded === false) &&
                !params.row.entradaRecebida &&
                (params.row.cancelamentosDocumentosEletronicos?.length === 0 ||
                  (params.row.cancelamentosDocumentosEletronicos?.length > 0 &&
                    params.row.cancelamentosDocumentosEletronicos[
                      params.row.cancelamentosDocumentosEletronicos?.length - 1
                    ]?.documentoCancelamento?.succeeded === true)) &&
                auth.perm.includes("u-ent") && (
                  <div
                    className="popOverMenu--option"
                    onClick={editarEntradaHandler.bind(null, params.row.id)}
                  >
                    <span>Editar</span>
                    <EditIcon className="popOverMenu--option__icon" />
                  </div>
                )}

              {/* GERAR PDF FRE - se existe documento eletronico e foi bem sucedido */}
              {auth.perm.includes("u-ent") &&
                params.row.documentoEletronico?.succeeded && (
                  <div
                    className="popOverMenu--option"
                    onClick={gerarPdfFaturaEletronicaHandlerEntrada.bind(
                      null,
                      params.row.id,
                    )}
                  >
                    <span>
                      Gerar PDF {params.row.documentoEletronico?.tipoDocumento}
                    </span>
                    <ArticleOutlinedIcon
                      className="popOverMenu--option__icon"
                      sx={{ color: "green" }}
                    />
                  </div>
                )}

              {auth.perm.includes("u-ent") && params.row.nrRecibo && (
                <div
                  className="popOverMenu--option"
                  onClick={gerarReciboInternoEntradas.bind(null, params.row.id)}
                >
                  <span>Gerar PDF Recibo Interno</span>
                  <ArticleOutlinedIcon
                    className="popOverMenu--option__icon"
                    sx={{ color: "gray" }}
                  />
                </div>
              )}

              {auth.perm.includes("u-ent") && params.row.nrRecibo && daMinhaUnidade && (
                <Popconfirm
                  title="Anular Recibo Interno"
                  description="Tem a certeza que pretende anular o recibo interno desta entrada?"
                  icon={<ErrorIcon style={{ color: "red" }} />}
                  okText="Sim"
                  cancelText="Não"
                  onConfirm={handleAnularReciboInternoEntrada.bind(
                    null,
                    params.row.id,
                  )}
                >
                  <div className="popOverMenu--option">
                    <span>Anular Recibo Interno</span>
                    <CancelIcon
                      className="popOverMenu--option__icon"
                      sx={{ color: "crimson" }}
                    />
                  </div>
                </Popconfirm>
              )}

              {/* GERAR PDF NCE*/}
              {auth.perm.includes("u-ent") &&
                params.row?.cancelamentosDocumentosEletronicos?.length > 0 &&
                params.row?.cancelamentosDocumentosEletronicos.map(
                  (can, index) => (
                    <div
                      className="popOverMenu--option"
                      onClick={gerarPdfFaturaEletronicaHandlerEntrada.bind(
                        null,
                        params.row.id,
                        "NCE",
                        can,
                      )}
                      key={"pdfNce2" + index}
                    >
                      <span>
                        Gerar PDF NCE {can.documentoCancelamento.nrDocumento}
                      </span>
                      <ArticleOutlinedIcon
                        className="popOverMenu--option__icon"
                        sx={{ color: "crimson" }}
                      />
                    </div>
                  ),
                )}

              {/*Emitir Fre para entrada*/}
              {auth.perm.includes("u-ent") &&
                daMinhaUnidade &&
                (!params.row.documentoEletronico ||
                  params.row.documentoEletronico?.succeeded === false) &&
                !params.row.nrRecibo &&
                (params.row.cancelamentosDocumentosEletronicos?.length === 0 ||
                  (params.row.cancelamentosDocumentosEletronicos?.length > 0 &&
                    params.row.cancelamentosDocumentosEletronicos[
                      params.row.cancelamentosDocumentosEletronicos?.length - 1
                    ]?.documentoCancelamento?.succeeded === true)) &&
                params.row.entradaRecebida &&
                params.row.tipoEntrada === "reembolso" && (
                  <Popconfirm
                    title="Fatura/Recibo Eletrónico - FRE"
                    description={`Pretende emitir a FRE${
                      modoContingenciaAtivo ? " em CONTINGÊNCIA" : ""
                    }?`}
                    icon={<ArticleOutlinedIcon style={{ color: "green" }} />}
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={verificarEEmitirDocumentoEntrada.bind(
                      null,
                      null,
                      params.row.id,
                      "FRE",
                      "atualizar",
                    )}
                  >
                    <div className="popOverMenu--option">
                      Emitir FRE{modoContingenciaAtivo && " (Contingência)"}
                      <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                    </div>
                  </Popconfirm>
                )}

              {auth.perm.includes("u-ent") &&
                daMinhaUnidade &&
                !params.row.nrRecibo &&
                (reciboSemRestricoes ||
                  params.row.metodoPagamento === "Dinheiro") &&
                (!params.row.documentoEletronico ||
                  params.row.documentoEletronico?.succeeded === false) &&
                (params.row.cancelamentosDocumentosEletronicos?.length === 0 ||
                  (params.row.cancelamentosDocumentosEletronicos?.length > 0 &&
                    params.row.cancelamentosDocumentosEletronicos[
                      params.row.cancelamentosDocumentosEletronicos?.length - 1
                    ]?.documento?.succeeded === false)) && (
                  <Popconfirm
                    title="Recibo Interno"
                    description={`Pretende emitir um recibo Interno?`}
                    icon={<ErrorIcon style={{ color: "red" }} />}
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={gerarReciboInternoEntradas.bind(
                      null,
                      params.row.id,
                    )}
                  >
                    <div className="popOverMenu--option">
                      <span>Gerar Recibo Interno</span>
                      <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                    </div>
                  </Popconfirm>
                )}

              {/*Emitir TVE para reembolsos*/}
              {auth.perm.includes("u-ent") &&
                daMinhaUnidade &&
                (!params.row.documentoEletronico ||
                  params.row.documentoEletronico?.succeeded === false) &&
                !params.row.nrRecibo &&
                (params.row.cancelamentosDocumentosEletronicos?.length === 0 ||
                  (params.row.cancelamentosDocumentosEletronicos?.length > 0 &&
                    params.row.cancelamentosDocumentosEletronicos[
                      params.row.cancelamentosDocumentosEletronicos?.length - 1
                    ]?.documentoCancelamento?.succeeded === true)) &&
                params.row.entradaRecebida && (
                  <Popconfirm
                    title="Talão de Venda Eletrónico - TVE"
                    description={`Pretende emitir a TVE${
                      modoContingenciaAtivo ? " em CONTINGÊNCIA" : ""
                    }?`}
                    icon={<ArticleOutlinedIcon style={{ color: "green" }} />}
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={verificarEEmitirDocumentoEntrada.bind(
                      null,
                      null,
                      params.row.id,
                      "TVE",
                      "atualizar",
                    )}
                  >
                    <div className="popOverMenu--option">
                      <span>
                        Emitir TVE{modoContingenciaAtivo && " (Contingência)"}
                      </span>
                      <ArticleOutlinedIcon className="popOverMenu--option__icon" />
                    </div>
                  </Popconfirm>
                )}

              {/* Comprovativo */}
              {auth.perm.includes("r-ent") &&
                params.row.comprovativo &&
                params.row.comprovativo.ficheiro && (
                  <a
                    href={`${process.env.REACT_APP_BACKEND_LINK}/${params.row.comprovativo.ficheiro}`}
                    download
                    target="_blank"
                    rel="noreferrer"
                  >
                    <div className="popOverMenu--option">
                      <span>Baixar Comprovativo</span>
                      <DownloadIcon className="popOverMenu--option__icon" />
                    </div>
                  </a>
                )}

              {/*CANCELAR RECEBIMENTO 1 - apenas para FTES, caso a entrada estiver paga, o documento enviado obteve sucesso e se caso houver um envio de NCE, esse foi bem sucedido */}
              {auth.perm.includes("u-ent") &&
                params.row.entradaRecebida &&
                daMinhaUnidade && (
                  <Popconfirm
                    title="Cancelar Recebimento"
                    description={`Pretende cancelar o recebimento da entrada - ${
                      params.row.descricao
                    } ${
                      params.row.documentoEletronico?.succeeded === true
                        ? ` e cancelar a/o ${params.row?.documentoEletronico?.tipoDocumento}`
                        : ""
                    }?`}
                    icon={<ErrorIcon style={{ color: "red" }} />}
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={handleBeforeCancelarRecebimentoEntrada.bind(
                      null,
                      params.row.id,
                      params.row.documentoEletronico?.succeeded ? true : false,
                    )}
                  >
                    <div className="popOverMenu--option">
                      <span>Cancelar recebimento</span>
                      <SettingsBackupRestoreIcon className="popOverMenu--option__icon" />
                    </div>
                  </Popconfirm>
                )}

              {/* DESATIVAR ENTRADA -  se não houver nenum tipo de documento fiscal com ou sem erro e a entrada não estiver recebida */}
              {auth.perm.includes("d-ent") &&
                daMinhaUnidade &&
                !params.row.documentoEletronico?.succeeded &&
                // (!params.row.cancelamentosDocumentosEletronicos ||
                //   params.row.cancelamentosDocumentosEletronicos?.length ===
                //     0)
                // &&
                !params.row.entradaRecebida &&
                auth.perm.includes("d-ent") && (
                  <Popconfirm
                    title="Desativar Entrada"
                    description={`Pretende desativar a entrada - ${params.row.descricao}?`}
                    icon={<ErrorIcon style={{ color: "red" }} />}
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={desativarEntradaHandler.bind(
                      null,
                      params.row.id,
                    )}
                  >
                    <div className="popOverMenu--option">
                      <span>Desativar</span>
                      <DeleteIcon className="popOverMenu--option__icon" />
                    </div>
                  </Popconfirm>
                )}
            </div>
          );
        }

        return (
          <>
            {params.row.estado !== "Pago" &&
              params.row.tipo === "receita" &&
              params.row.quantiaPorPagar !== 0 &&
              !params.row.motivoEncerramento &&
              // Um orçamento de outra unidade PODE ser pago aqui: o dinheiro
              // fica registado nesta unidade, que passa a ser a da receita.
              //
              // A exceção é a fatura já emitida: receber emite o recibo, e o
              // recibo tem de sair pelo LED da fatura. Aí o botão fica
              // acinzentado com a razão, em vez de desaparecer.
              auth.perm.includes("u-parc") &&
              (docBloqueado ? (
                <span
                  className="debitos__container__receber debitos__container__receber--bloqueada"
                  title={motivoDoc}
                >
                  Receber
                </span>
              ) : (
                <span
                  className={`debitos__container__receber ${
                    params.row.estado === "Em atraso" &&
                    "debitos__container__receber--atraso"
                  }`}
                  onClick={handleOpenModalReceber.bind(
                    null,
                    params.row.id,
                    params.row.valor,
                    params.row.descricao || "",
                  )}
                >
                  Receber
                </span>
              ))}

            {/* Receber uma entrada de OUTRA unidade não se permite.
                Ao contrário de um orçamento — uma venda que pode ser paga em
                qualquer balcão, porque o dinheiro é de quem recebe — uma
                entrada É o movimento de dinheiro. Recebê-la daqui punha o
                valor na caixa desta unidade quando o registo é do outro. */}
            {params.row.tipo === "entrada" &&
              !params.row.entradaRecebida &&
              podeAlterarRegisto(
                params.row.estabelecimento || params.row.caixa?.estabelecimento,
                auth,
              ) &&
              auth.perm.includes("u-ent") && (
                <span
                  className={`debitos__container__receber ${
                    params.row.estado === "Em atraso" &&
                    "debitos__container__receber--atraso"
                  }`}
                  onClick={handleOpenModalReceberEntrada.bind(
                    null,
                    params.row.id,
                  )}
                >
                  Receber
                </span>
              )}

            {content && (
              <Space wrap>
                <Popover content={content} trigger="click" placement="bottom">
                  <div className="dots__menu">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                </Popover>
              </Space>
            )}
          </>
        );
      },
    },
  ];

  //UTIL
  const validarDadosCliente = (cliente, tipoDocumento) => {
    // Se for TVE, não precisa validar dados do cliente
    if (tipoDocumento === "TVE") {
      return { valido: true };
    }

    if (!cliente.nif) {
      return { valido: false, erro: "O cliente não possui um nif" };
    }

    if (!cliente.nomeFiscal?.trim()) {
      return { valido: false, erro: "O cliente não possui um nome fiscal!" };
    }

    if (!cliente.contacto?.trim()) {
      return {
        valido: false,
        erro: "O cliente não possui um número de telefone",
      };
    }

    if (!cliente.endereco?.trim()) {
      return { valido: false, erro: "O cliente não possui um endereço" };
    }

    if (!cliente.pais) {
      return { valido: false, erro: "O cliente não possui um pais" };
    }

    if (
      (cliente.nif === "000000000" || cliente.nif === "999999999") &&
      tipoDocumento === "FRE"
    ) {
      return {
        valido: false,
        erro: "Nifs 000000000 ou 999999999 não são válidos para FREs.",
      };
    }

    return { valido: true };
  };

  // Handlers do Dialog de Contingência
  const handleDialogContingenciaClose = () => {
    setDialogContingenciaOpen(false);
    setDadosContingenciaPendente(null);
    setDadosCancelamentoPendente(null);
    setMotivoContingenciaSelecionado(1);
    setDescricaoContingenciaOutro("");
  };

  const handleConfirmarContingencia = async () => {
    if (!dadosContingenciaPendente && !dadosCancelamentoPendente) return;

    setDialogContingenciaOpen(false);
    startLoading();

    try {
      const motivoSelecionado = MOTIVOS_CONTINGENCIA.find(
        (m) => m.codigo === motivoContingenciaSelecionado,
      );

      const dadosContingencia = {
        ReasonTypeCode: motivoContingenciaSelecionado,
        ReasonDescription:
          motivoContingenciaSelecionado === 0
            ? descricaoContingenciaOutro
            : motivoSelecionado?.label,
      };

      // Caso seja emissão de FRE/TVE
      if (dadosContingenciaPendente) {
        const dadosComContingencia = {
          ...dadosContingenciaPendente.dados,
          emitirEmContingencia: true,
          ...dadosContingencia,
        };

        if (dadosContingenciaPendente.tipo === "parcela") {
          await executarEmissaoParcela(dadosComContingencia);
        } else if (dadosContingenciaPendente.tipo === "entrada") {
          await executarEmissaoEntrada(
            dadosComContingencia,
            dadosContingenciaPendente.operacao,
          );
        }

        toast.success(
          "Documento emitido em CONTINGÊNCIA. Será transmitido quando o servidor voltar online.",
        );
      }

      // Caso seja cancelamento (NCE)
      if (dadosCancelamentoPendente) {
        const dadosCancelamentoComContingencia = {
          ...dadosCancelamentoPendente.dadosCancelamento,
          emitirEmContingencia: true,
          online: false,
          ...dadosContingencia,
        };

        if (dadosCancelamentoPendente.tipo === "cancelamentoParcela") {
          await executarCancelamentoParcela(
            dadosCancelamentoComContingencia,
            dadosCancelamentoPendente.contaFiltrada,
          );
        } else if (dadosCancelamentoPendente.tipo === "cancelamentoEntrada") {
          await executarCancelamentoEntrada(dadosCancelamentoComContingencia);
        } else if (dadosCancelamentoPendente.tipo === "anularFTEParcela") {
          await executarEmissaoNCEParcelaComFTE(
            dadosCancelamentoComContingencia,
          );
        } else if (dadosCancelamentoPendente.tipo === "anularRCEParcela") {
          await executarAnularRCEParcela(dadosCancelamentoComContingencia);
        }

        toast.success(
          "NCE emitida em CONTINGÊNCIA. Será transmitida quando o servidor voltar online.",
        );
      }
    } catch (err) {
      console.error("Erro ao emitir em contingência:", err);
      toast.error("Erro ao emitir documento em contingência");
    } finally {
      setDadosContingenciaPendente(null);
      setDadosCancelamentoPendente(null);
      setMotivoContingenciaSelecionado(1);
      setDescricaoContingenciaOutro("");
      stopLoading();
    }
  };

  // Função auxiliar para executar cancelamento de parcela
  const executarCancelamentoParcela = async (
    dadosCancelamento,
    contaFiltrada,
  ) => {
    const formData = new FormData();
    formData.append("dadosCancelamento", JSON.stringify(dadosCancelamento));

    const resposta = await sendRequest(
      `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/cancelarrecebimento`,
      "POST",
      formData,
      {
        Authorization: "Bearer " + auth.token,
      },
    );

    setContaCorrente(resposta.contaCorrente);

    if (resposta.documento?.responseData?.responses[0]?.succeeded) {
      await marcarCanDeleteFalse(contaFiltrada);
    }
  };

  // Função auxiliar para executar cancelamento de entrada
  const executarCancelamentoEntrada = async (dadosCancelamento) => {
    const formData = new FormData();
    formData.append("dadosCancelamento", JSON.stringify(dadosCancelamento));

    const resposta = await sendRequest(
      `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/cancelarrecebimentocomdocumento`,
      "POST",
      formData,
      { Authorization: "Bearer " + auth.token },
    );

    updateEntradas(resposta.entrada, "atualizar");
  };

  const executarEmissaoNCEParcelaComFTE = async (dadosCancelamento) => {
    const formData = new FormData();
    formData.append("dadosCancelamento", JSON.stringify(dadosCancelamento));

    const resposta = await sendRequest(
      `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/parcelas/emitirnceparafte`,
      "POST",
      formData,
      { Authorization: "Bearer " + auth.token },
    );

    if (!resposta) throw new Error("Não houve resposta do servidor");

    setContaCorrente(resposta.contaCorrente);

    if (resposta.documento?.respostaEfatura?.responses[0]?.succeeded) {
      const msgContingencia = resposta.documento?.emitidoEmContingencia
        ? " em CONTINGÊNCIA"
        : "";
      toast.success(`NCE emitida com sucesso${msgContingencia}`);
    } else {
      toast.error(
        `Erro ao emitir NCE: ${resposta.documento?.respostaEfatura?.responses[0]?.messages?.[0]?.description}`,
      );
    }
  };

  // Função auxiliar para executar emissão de parcela
  const executarEmissaoParcela = async (dadosEmissao) => {
    const formData = new FormData();
    formData.append("dadosEmissao", JSON.stringify(dadosEmissao));

    const resposta = await sendRequest(
      `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/emitirdoceletronicoeatualizar`,
      "POST",
      formData,
      {
        Authorization: "Bearer " + auth.token,
      },
    );

    if (!resposta) {
      throw new Error("Não houve resposta da Efatura");
    }

    setContaCorrente(resposta.contaCorrente);

    if (resposta.documento?.respostaEfatura?.responses[0]?.succeeded) {
      const tipoDoc = dadosEmissao.tipoDocEletronico;
      const msgContingencia = resposta.documento?.emitidoEmContingencia
        ? " em CONTINGÊNCIA"
        : "";
      toast.success(`${tipoDoc} emitido com sucesso${msgContingencia}`);
    } else {
      toast.error(
        `Erro ao emitir ${dadosEmissao.tipoDocEletronico}. ${resposta.documento?.respostaEfatura?.responses[0]?.messages[0]?.description}`,
      );
    }
  };

  const executarEmissaoFTE = async (dadosEmissao) => {
    const formData = new FormData();
    formData.append("dadosEmissao", JSON.stringify(dadosEmissao));
    const resposta = await sendRequest(
      `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/parcelas/emitirfte`,
      "POST",
      formData,
      { Authorization: "Bearer " + auth.token },
    );
    if (!resposta) throw new Error("Não houve resposta do servidor");
    setContaCorrente(resposta.contaCorrente);
    if (resposta.documento?.respostaEfatura?.responses[0]?.succeeded) {
      toast.success(
        `FTE emitida com sucesso${resposta.documento?.emitidoEmContingencia ? " em CONTINGÊNCIA" : ""}`,
      );
    } else {
      toast.error(
        `Erro ao emitir FTE. ${resposta.documento?.respostaEfatura?.responses[0]?.messages[0]?.description}`,
      );
    }
  };

  const executarEmissaoRCE = async (dadosEmissao) => {
    const formData = new FormData();
    formData.append("dadosEmissao", JSON.stringify(dadosEmissao));
    const resposta = await sendRequest(
      `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/parcelas/emitirrce`,
      "POST",
      formData,
      { Authorization: "Bearer " + auth.token },
    );
    if (!resposta) throw new Error("Não houve resposta do servidor");
    setContaCorrente(resposta.contaCorrente);
    if (resposta.documento?.respostaEfatura?.responses[0]?.succeeded) {
      toast.success(
        `RCE emitido com sucesso${resposta.documento?.emitidoEmContingencia ? " em CONTINGÊNCIA" : ""}`,
      );
    } else {
      toast.error(
        `Erro ao emitir RCE. ${resposta.documento?.respostaEfatura?.responses[0]?.messages[0]?.description}`,
      );
    }
  };

  const emitirFTEHandler = async (id, idConta) => {
    startLoading();
    try {
      const { parcelaFiltrada, contaFiltrada } = encontrarParcelaEConta(id);

      const validacao = validarDadosCliente(contaCorrente.cliente, "FTE");
      if (!validacao.valido) {
        toast.error(validacao.erro);
        return;
      }

      const dadosEmissao = {
        tipoDocEletronico: "FTE",
        contaCorrenteId: contaCorrente._id,
        contaId: contaFiltrada._id,
        parcelaId: parcelaFiltrada._id,
        valor:
          parcelaFiltrada.quantiaPorPagar > 0
            ? parcelaFiltrada.quantiaPorPagar
            : parcelaFiltrada.quantiaPaga,
        descricaoPagamento:
          parcelaFiltrada.descricao?.trim() || "Tratamento dentário",
        dataLimitePagamento: parcelaFiltrada.dataLimitePagamento,
        usuarioEmissor: auth.userId,
        online: true,
        nomeCliente: contaCorrente.cliente.nomeFiscal,
        nifCliente: contaCorrente.cliente.nif,
        contactoCliente: contaCorrente.cliente.contacto,
        codigoPaisCliente: contaCorrente.cliente.pais.codigo,
        moradaCliente: contaCorrente.cliente.endereco,
        clinicaId: clinica.clinica._id,
        clinica: {
          nif: clinica.clinica.nif,
          nomeFiscal: clinica.clinica.nomeFiscal,
          endereco: clinica.clinica.endereco,
          contacto: clinica.clinica.contacto,
          email: clinica.clinica.email,
        },
      };

      await executarEmissaoFTE(dadosEmissao);
    } catch (err) {
      console.error("Erro ao emitir FTE:", err);
      toast.error("Ocorreu um erro ao emitir a FTE");
    } finally {
      stopLoading();
    }
  };

  const emitirRCEHandler = async (id, idConta) => {
    startLoading();
    try {
      const { parcelaFiltrada, contaFiltrada } = encontrarParcelaEConta(id);

      const validacao = validarDadosCliente(contaCorrente.cliente, "RCE");
      if (!validacao.valido) {
        toast.error(validacao.erro);
        return;
      }

      // A FTE da parcela vive em documentoEletronico (só migra para
      // faturaEReciboEletronicos.fte depois da RCE ser emitida).
      const fte = parcelaFiltrada.documentoEletronico;

      const dadosEmissao = {
        tipoDocEletronico: "RCE",
        contaCorrenteId: contaCorrente._id,
        contaId: contaFiltrada._id,
        parcelaId: parcelaFiltrada._id,
        valor: parcelaFiltrada.quantiaPaga,
        descricaoPagamento:
          parcelaFiltrada.descricao?.trim() || "Tratamento dentário",
        dataPagamento: parcelaFiltrada.dataPagamento,
        metodoPagamento: parcelaFiltrada.metodoPagamento,
        IUDReceber: fte.entryName.replace(/\.xml$/, ""),
        innerDocumentNumber: fte.nrDocumento,
        usuarioEmissor: auth.userId,
        online: true,
        nomeCliente: contaCorrente.cliente.nomeFiscal,
        nifCliente: contaCorrente.cliente.nif,
        contactoCliente: contaCorrente.cliente.contacto,
        codigoPaisCliente: contaCorrente.cliente.pais.codigo,
        moradaCliente: contaCorrente.cliente.endereco,
        clinicaId: clinica.clinica._id,
        clinica: {
          nif: clinica.clinica.nif,
          nomeFiscal: clinica.clinica.nomeFiscal,
          endereco: clinica.clinica.endereco,
          contacto: clinica.clinica.contacto,
          email: clinica.clinica.email,
        },
      };

      await executarEmissaoRCE(dadosEmissao);
    } catch (err) {
      console.error("Erro ao emitir RCE:", err);
      toast.error("Ocorreu um erro ao emitir o RCE");
    } finally {
      stopLoading();
    }
  };

  // Função auxiliar para executar emissão de entrada
  const executarEmissaoEntrada = async (
    dadosEmissao,
    operacao = "atualizar",
  ) => {
    const formData = new FormData();
    formData.append("dadosEmissao", JSON.stringify(dadosEmissao));

    const resposta = await sendRequest(
      `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/emitirdoceletronicoeatualizar`,
      "POST",
      formData,
      { Authorization: "Bearer " + auth.token },
    );

    if (!resposta) {
      throw new Error("Não houve resposta do servidor");
    }

    updateEntradas(resposta.entrada, operacao);

    if (resposta.documento?.respostaEfatura?.responses[0]?.succeeded) {
      const tipoDoc = dadosEmissao.tipoDocEletronico;
      const msgContingencia = resposta.documento?.emitidoEmContingencia
        ? " em CONTINGÊNCIA"
        : "";
      toast.success(`${tipoDoc} emitido com sucesso${msgContingencia}`);
    } else {
      toast.error(
        `Erro ao emitir ${dadosEmissao.tipoDocEletronico}: ${resposta.documento?.respostaEfatura?.responses[0]?.messages[0]?.description}`,
      );
    }
  };
  return (
    <>
      <div className="debitos__container caixa">
        <ModalInfo {...modalProps} />
        <div className="debitos__container__cabecalho">
          <div
            className="checkbox-wrapper-51"
            id="debitos__container__cabecalho__mostrar-recebidos"
          >
            <input
              type="checkbox"
              id="mostrarRecebidos"
              onChange={(e) => setMostrarRecebidos(e.target.checked)}
              checked={mostrarRecebidos}
            />
            <label htmlFor="mostrarRecebidos" className="toggle">
              <span>
                <svg width="10px" height="10px" viewBox="0 0 10 10">
                  <path d="M5,1 L5,1 C2.790861,1 1,2.790861 1,5 L1,5 C1,7.209139 2.790861,9 5,9 L5,9 C7.209139,9 9,7.209139 9,5 L9,5 C9,2.790861 7.209139,1 5,1 L5,9 L5,1 Z"></path>
                </svg>
              </span>
            </label>
            <span className="checkbox-text">Mostrar Recebidos</span>
          </div>

          <div>
            {/* Ícone de Observações */}
            <Tooltip title="Observações da conta">
              <IconButton
                onClick={() => setModalNotasOpen(true)}
                sx={{ ml: 2 }}
              >
                <Badge
                  badgeContent={clienteData?.notasDebitos?.length || 0}
                  color={
                    clienteData?.notasDebitos?.some((n) => n.tipo === "urgente")
                      ? "error"
                      : clienteData?.notasDebitos?.some(
                            (n) => n.tipo === "importante",
                          )
                        ? "warning"
                        : "primary"
                  }
                >
                  <CommentIcon
                    sx={{
                      color: clienteData?.notasDebitos?.some(
                        (n) => n.tipo === "urgente",
                      )
                        ? "#f44336"
                        : clienteData?.notasDebitos?.some(
                              (n) => n.tipo === "importante",
                            )
                          ? "#ff9800"
                          : "action.active",
                    }}
                  />
                </Badge>
              </IconButton>
            </Tooltip>
          </div>
          <div className="debitos__container__cabecalho__totais">
            {mostrarRecebidos && (
              <div className="debitos__container__cabecalho__totais--recebido">
                <span>Total Recebido</span>
                <span>{totalRecebido}$00</span>
              </div>
            )}
            <div className="debitos__container__cabecalho__totais--por-receber">
              <span>Total a receber</span>
              <span>{totalReceber}$00</span>
            </div>
          </div>

          <div
            style={{ justifySelf: "flex-end", display: "flex", gap: "8px" }}
          >
            {/* ⛔ DESLIGADO A 2026-10-26 — fica fora da 1.5.8.
                Falta testar, e a entrada das notas de atualização foi movida
                para a lista do que ainda não pode sair. Para o voltar a ligar
                basta descomentar: o modal, o estado `mostrarExtrato` e o
                `showExtrato` continuam todos montados.

                O extrato segue a mesma permissao de LEITURA da aba: quem ve os
                debitos ve o extrato deles. Nao pede `c-ent`, que e permissao
                de CRIAR entradas — tirar um extrato nao cria nada.

            <Button
              variant="outlined"
              color="primary"
              onClick={() => setMostrarExtrato(true)}
            >
              Extrato
            </Button>
            */}

            {auth.perm.includes("c-ent") && (
              <Button
                variant="contained"
                color="success"
                id="basic-button"
                onClick={(e) => setModalData({ open: "entrada" })}
              >
                + Adicionar Entrada
              </Button>
            )}
          </div>
        </div>
        {contaCorrente &&
          contaCorrente.contas
            .filter((conta) => conta.aprovado === true)
            .sort((a, b) => {
              // Helper function to determine if conta should be expanded
              const shouldBeExpanded = (conta) =>
                !conta.contaLiquidada &&
                conta.total !== 0 &&
                conta.status !== "INTERROMPIDO";

              // Sort expanded first (returns -1), collapsed last (returns 1)
              if (shouldBeExpanded(a) && !shouldBeExpanded(b)) return -1;
              if (!shouldBeExpanded(a) && shouldBeExpanded(b)) return 1;
              return 0;
            })
            .map((conta) => {
              // Skip if we're not showing received and all parcelas are paid
              if (
                !mostrarRecebidos &&
                conta.parcelas.every((p) => p.parcelaPaga)
              ) {
                return null;
              }

              // Calculate conta totals
              const totalPago = conta.parcelas.reduce(
                (sum, p) => sum + (p.quantiaPaga || 0),
                0,
              );
              const totalPorPagar = conta.parcelas.reduce(
                (sum, p) => sum + (p.quantiaPorPagar || 0),
                0,
              );

              return (
                <Accordion
                  key={conta._id}
                  defaultExpanded={
                    !conta.contaLiquidada &&
                    conta.total !== 0 &&
                    conta.status !== "INTERROMPIDO"
                  }
                  sx={{
                    mb: 2,
                    "&:before": {
                      display: "none",
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon
                        sx={{
                          fontSize: "2rem",
                          "&:hover": {
                            transform: "scale(1.2)",
                            color: "primary.main",
                            filter: "brightness(1.2)",
                            transition: "all 0.2s ease-in-out",
                          },
                        }}
                      />
                    }
                    sx={{
                      height: "55px",
                      backgroundColor:
                        conta.status === "INTERROMPIDO"
                          ? "#fff8f8"
                          : conta.total === 0
                            ? "#f9feff"
                            : "#fdfdfd",
                      borderLeft:
                        conta.status === "INTERROMPIDO"
                          ? "4px solid #eb3c5f"
                          : conta.total === 0
                            ? "4px solid #1976d2"
                            : "4px solid #4caf50",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <BadgeUnidade
                          estabelecimento={conta.orcamento?.estabelecimento}
                        />
                        {/* Sem isto o menu "Ações" some sem explicação. Não diz
                            "só consulta" porque não é verdade: receber e
                            cancelar recebimentos continua a poder fazer-se
                            daqui. O que é de lá é a venda. */}
                        <SeloSoConsulta
                          estabelecimento={conta.orcamento?.estabelecimento}
                          texto="venda de outra unidade"
                        />
                        <span className="debitos__accordion__title">
                          Orçamento #{conta.orcamento?.codigo || "N/A"} -{" "}
                          {conta.orcamento?.orcamentoMisto
                            ? "Misto"
                            : conta.orcamento?.beneficio}{" "}
                          {conta.orcamento?.modalidadePagamento ===
                          "REEMBOLSO_CLIENTE"
                            ? " - Reembolso"
                            : ""}
                        </span>
                        {conta.status === "INTERROMPIDO" && (
                          <Chip
                            label="Tratamento Interrompido"
                            size="small"
                            sx={{
                              color: "#eb3c5f",
                              backgroundColor:
                                "rgba(241, 167, 182, 0.4745098039)",
                            }}
                          />
                        )}

                        {conta.total === 0 && (
                          <Chip
                            label="Isento de Pagamento"
                            size="small"
                            sx={{
                              color: "#1976D2",
                              backgroundColor: "#bbdefb4f",
                            }}
                          />
                        )}

                        {conta.contaLiquidada && conta.total !== 0 && (
                          <Chip
                            label="Liquidada"
                            size="small"
                            sx={{
                              color: "#12d453",
                              backgroundColor: "#e5faec",
                            }}
                          />
                        )}

                        {/* Botao de ação */}
                        {/* -------------------------------------------------------- */}
                        {
                          // (!conta.contaLiquidada || conta.total === 0) &&
                          // Este menu é sobre a VENDA — aprovar, substituir,
                          // descontos, credencial, majoração. Só na unidade que
                          // orçamentou: é dela o preço e a responsabilidade
                          // pelo que foi vendido.
                          //
                          // Receber e cancelar recebimentos NÃO passam por aqui:
                          // vivem nos três pontos de cada parcela e ficam
                          // livres, porque a receita é de quem recebe.
                          podeAlterarRegisto(
                            conta.orcamento?.estabelecimento,
                            auth,
                          ) &&
                          ((conta.orcamento.ativo &&
                            conta.aprovado &&
                            !conta.motivoEncerramento) ||
                            conta.motivoEncerramento) && (
                            <Box sx={{ display: "flex", gap: 1 }}>
                              <Button
                                size="small"
                                onClick={(event) =>
                                  handleClickMenu(event, conta)
                                }
                                variant="contained"
                                disableElevation
                                color="primary"
                                sx={{ textTransform: "none" }}
                                endIcon={<ExpandMoreIcon />}
                              >
                                Ações
                              </Button>
                              <Menu
                                anchorEl={menuState.anchorEl}
                                open={Boolean(menuState.anchorEl)}
                                onClose={handleCloseMenu}
                                onClick={(e) => e.stopPropagation()}
                                MenuListProps={{
                                  "aria-labelledby": "basic-button",
                                }}
                                TransitionProps={{
                                  onExited: () => {
                                    setMenuState((prev) => ({
                                      ...prev,
                                      selectedConta: null,
                                      isClosing: false,
                                    }));
                                  },
                                }}
                              >
                                {menuState.selectedConta &&
                                  !menuState.isClosing &&
                                  (menuState.selectedConta.motivoEncerramento &&
                                  auth.perm.includes("u-pend") ? (
                                    <MenuItem
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        handleConfirmRestaurarPendencia(
                                          menuState.selectedConta,
                                        );
                                        handleCloseMenu();
                                      }}
                                      sx={{
                                        color: "#273445",
                                        "&:hover": {
                                          backgroundColor: "#f5f5f5",
                                        },
                                      }}
                                    >
                                      <HistoryIcon
                                        sx={{ mr: 1, color: "#88959e" }}
                                      />
                                      Restaurar Pendências
                                    </MenuItem>
                                  ) : (
                                    // Replace the array with conditional rendering
                                    <>
                                      {auth.perm.includes("u-desc") && (
                                        <MenuItem
                                          onClick={(event) => {
                                            event.stopPropagation();
                                            handleOpenModalEditarDesconto(
                                              menuState.selectedConta,
                                            );
                                            handleCloseMenu();
                                          }}
                                          sx={{
                                            color: "#273445",
                                            "&:hover": {
                                              backgroundColor: "#f5f5f5",
                                            },
                                          }}
                                        >
                                          <DiscountIcon
                                            sx={{ mr: 1, color: "#88959e" }}
                                          />
                                          Editar Desconto
                                        </MenuItem>
                                      )}

                                      {auth.perm.includes("u-maj") &&
                                        menuState.selectedConta.orcamento
                                          .beneficio === "INPS" &&
                                        conta.orcamento?.modalidadePagamento !==
                                          "REEMBOLSO_CLIENTE" && (
                                          <MenuItem
                                            onClick={(event) => {
                                              event.stopPropagation();
                                              handleOpenModalEditarMajoracao(
                                                menuState.selectedConta,
                                              );
                                              handleCloseMenu();
                                            }}
                                            sx={{
                                              color: "#273445",
                                              "&:hover": {
                                                backgroundColor: "#f5f5f5",
                                              },
                                            }}
                                          >
                                            <TrendingUpIcon
                                              sx={{
                                                mr: 1,
                                                color: "#88959e",
                                              }}
                                            />
                                            Editar Majoração
                                          </MenuItem>
                                        )}

                                      {auth.perm.includes("u-pend") &&
                                        menuState.selectedConta.parcelas.some(
                                          (parcela) =>
                                            parcela.quantiaPorPagar !== 0,
                                        ) && (
                                          <MenuItem
                                            onClick={(event) => {
                                              event.stopPropagation();
                                              handleOpenModalCancelamentoPendencias(
                                                menuState.selectedConta,
                                              );
                                              handleCloseMenu();
                                            }}
                                            sx={{
                                              color: "#273445",
                                              "&:hover": {
                                                backgroundColor: "#f5f5f5",
                                              },
                                            }}
                                          >
                                            <CancelIcon
                                              sx={{
                                                mr: 1,
                                                color: "#88959e",
                                              }}
                                            />
                                            Terminar Pendências
                                          </MenuItem>
                                        )}
                                    </>
                                  ))}
                              </Menu>
                            </Box>
                          )
                        }
                        {/* -------------------------------------------------------- */}
                      </Box>
                      <Box sx={{ display: "flex", gap: 3 }}>
                        {mostrarRecebidos && conta.total !== 0 && (
                          <Box>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Total Recebido
                            </Typography>
                            <Typography color="success.main">
                              {totalPago.toLocaleString("pt-BR")}$00
                            </Typography>
                          </Box>
                        )}
                        {conta.total !== 0 && (
                          <Box sx={{ marginRight: "25px" }}>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {conta.motivoEncerramento
                                ? "Total Pendente"
                                : "Total a Receber"}
                            </Typography>
                            <Typography color="error.main">
                              {totalPorPagar.toLocaleString("pt-BR")}$00
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    {conta.status === "INTERROMPIDO" && (
                      <Alert
                        severity="info"
                        sx={{ mb: 2 }}
                        icon={
                          conta.motivoEncerramento?.descricao ? (
                            <Tooltip
                              title={conta.motivoEncerramento?.descricao}
                            >
                              <InfoIcon sx={{ cursor: "help" }} />
                            </Tooltip>
                          ) : (
                            <InfoIcon />
                          )
                        }
                      >
                        <Typography variant="body2">
                          <strong>Motivo da Interrupção:</strong>{" "}
                          {conta.motivoEncerramento?.tipo}
                          <br />
                          <div style={{ marginTop: "7px" }}>
                            <strong>Data:</strong>{" "}
                            {moment(conta.motivoEncerramento?.data).format(
                              "DD-MM-YYYY",
                            )}{" "}
                            <strong style={{ marginLeft: "15px" }}>
                              Responsável:{" "}
                            </strong>
                            {conta.motivoEncerramento?.responsavel?.name}
                          </div>
                        </Typography>
                      </Alert>
                    )}

                    {/* Your existing DataGrid for this conta's parcelas */}
                    <div
                      style={{
                        height: Math.min(165 + conta.nrParcelas * 45, 380),
                        width: "100%",
                      }}
                    >
                      <DataGrid
                        rows={rows.filter((row) => row.contaId === conta._id)}
                        columns={actionColumn}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                      />
                    </div>
                  </AccordionDetails>
                </Accordion>
              );
            })}
        {/* Entradas */}
        {entradas && entradas.length > 0 && auth.perm.includes("r-ent") && (
          <Accordion
            key={"entradas1"}
            defaultExpanded={true}
            sx={{
              mb: 2,
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon
                  sx={{
                    fontSize: "2rem",
                    "&:hover": {
                      transform: "scale(1.2)",
                      color: "primary.main",
                      filter: "brightness(1.2)",
                      transition: "all 0.2s ease-in-out",
                    },
                  }}
                />
              }
              sx={{
                height: "55px",
                backgroundColor: "#eafdff",
                borderLeft: "4px solid #00BCD4",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <span className="debitos__accordion__title">Entradas</span>
                  {/* -------------------------------------------------------- */}
                </Box>
                <Box sx={{ display: "flex", gap: 3 }}>
                  {mostrarRecebidos && (
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Total Recebido
                      </Typography>
                      <Typography color="success.main">
                        {entradas
                          .reduce(
                            (sum, e) => sum + (e.entradaRecebida ? e.valor : 0),
                            0,
                          )
                          .toLocaleString("pt-BR")}
                        $00
                      </Typography>
                    </Box>
                  )}
                  <Box sx={{ marginRight: "25px" }}>
                    <Typography variant="caption" color="text.secondary">
                      Total a Receber
                    </Typography>
                    <Typography color="error.main">
                      {entradas
                        .reduce(
                          (sum, e) => sum + (e.entradaRecebida ? 0 : e.valor),
                          0,
                        )
                        .toLocaleString("pt-BR")}
                      $00
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              {/* Your existing DataGrid for this conta's parcelas */}
              <div
                style={{
                  height: Math.min(165 + entradas.length * 45, 380),
                  width: "100%",
                }}
              >
                <DataGrid
                  rows={rows.filter((row) => row.tipo === "entrada")}
                  columns={actionColumn}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                />
              </div>
            </AccordionDetails>
          </Accordion>
        )}

        {openModal === "receber" && (
          <ModalReceber
            open={openModal === "receber"}
            handleCloseModalReceber={handleCloseModal}
            nomeCliente={nomeCliente}
            valorAPagar={parseFloat(valor.slice(0, -3).replace(".", ""))}
            contaCorr={contaCorrente}
            idParcela={idParcela}
            descParcela={descricaoParcela}
            sendRequest={sendRequest}
            updateContaCorrente={updateContaCorrente}
            modoContingenciaAtivo={modoContingenciaAtivo}
          />
        )}

        {openModal === "procedimentos" && (
          <ModalVerOrcamento
            open={openModal === "procedimentos"}
            handleClose={handleCloseModal}
            data={modalData}
          />
        )}

        {corrigirCaixa && (
          <ModalCorrigirCaixa
            open={!!corrigirCaixa}
            tipo={corrigirCaixa.tipo}
            id={corrigirCaixa.id}
            onFechar={() => setCorrigirCaixa(null)}
            onCorrigido={() => setRecarga((n) => n + 1)}
          />
        )}

        {openModal === "verReceita" && (
          <ModalVerReceita
            open={openModal === "verReceita"}
            handleCloseModalVerReceita={handleCloseModal}
            dadosDaReceita={modalData}
            nomeCliente={nomeCliente}
          />
        )}

        {openModal === "editarDesconto" && (
          <ModalEditarDesconto
            open={openModal === "editarDesconto"}
            handleCloseModalEditarDesconto={handleCloseModal}
            modalData={modalData}
            updateContaCorrente={updateContaCorrente}
            contaCorrente={contaCorrente}
            auth={auth}
          />
        )}

        <ModalExtrato
          aberto={mostrarExtrato}
          fechar={() => setMostrarExtrato(false)}
          clienteId={clienteId}
          clienteData={clienteData}
          showExtrato={showExtrato}
        />

        {openModal === "editarMajoracao" && (
          <ModalEditarMajoracao
            open={openModal === "editarMajoracao"}
            handleCloseModalEditarMajoracao={handleCloseModal}
            modalData={modalData}
            updateContaCorrente={updateContaCorrente}
            contaCorrente={contaCorrente}
            auth={auth}
          />
        )}

        {openModal === "cancelarPendencias" && (
          <ModalMotivoCancelamentoPendencias
            open={openModal === "cancelarPendencias"}
            handleCloseModalCancelarPendencias={handleCloseModal}
            modalData={modalData}
            updateContaCorrente={updateContaCorrente}
            contaCorrente={contaCorrente}
            auth={auth}
            sendRequest={sendRequest}
            clinicaId={clinica.clinica._id}
          />
        )}

        {dadosModalMotivoCancelamento.open && (
          <ModalMotivoCancelamento
            open={dadosModalMotivoCancelamento.open}
            handleCloseModal={handleCloseModal}
            modalData={dadosModalMotivoCancelamento}
            handleCancelarRecebimento={handleCancelarRecebimento}
            handleCancelarRecebimentoEntrada={handleCancelarRecebimentoEntrada}
            clinica={clinica}
            auth={auth}
          />
        )}

        {openModal === "verEntrada" && (
          <ModalVerEntrada
            openModalVerEntrada={openModal === "verEntrada"}
            handleCloseModalVerEntrada={handleCloseModal}
            dadosModalVerEntrada={modalData}
          />
        )}
        {modalData?.open === "editarEntrada" && (
          <ModalEditarEntradaDebito
            openModalEditarEntrada={modalData?.open === "editarEntrada"}
            sendRequest={sendRequest}
            handleCloseModalEditarEntrada={handleCloseModal}
            clinicaId={clinica.clinica._id}
            auth={auth}
            updateEntradas={updateEntradas}
            entrada={modalData.entrada}
            emitirDocEletronicoEntradas={emitirDocEletronicoEntradas}
            cliente={clienteData}
            modoContingenciaAtivo={modoContingenciaAtivo}
          />
        )}
        {modalData?.open === "receberEntrada" && (
          <ModalReceberEntradaDebito
            openModalReceberEntrada={modalData?.open === "receberEntrada"}
            sendRequest={sendRequest}
            handleCloseModalReceberEntrada={handleCloseModal}
            auth={auth}
            updateEntradas={updateEntradas}
            entrada={modalData.entrada}
            cliente={clienteData}
            clinicaId={clinica.clinica._id}
            emitirDocEletronicoEntradas={emitirDocEletronicoEntradas}
            modoContingenciaAtivo={modoContingenciaAtivo}
          />
        )}

        {modalData?.open === "entrada" && (
          <ModalEntradaDebito
            openModalEntrada={modalData.open === "entrada"}
            sendRequest={sendRequest}
            handleCloseModalEntrada={handleCloseModal}
            clinicaId={clinica.clinica._id}
            auth={auth}
            updateEntradas={updateEntradas}
            emitirDocEletronicoEntradas={emitirDocEletronicoEntradas}
            cliente={clienteData}
            modoContingenciaAtivo={modoContingenciaAtivo}
          />
        )}

        {modalNotasOpen && (
          <ModalNotasDebitos
            open={modalNotasOpen}
            handleClose={() => setModalNotasOpen(false)}
            clienteId={clienteId}
            nomeCliente={nomeCliente}
            sendRequest={sendRequest}
            auth={auth}
            onNotasUpdate={changeClienteNotasData}
            notasDebitos={clienteData?.notasDebitos || []}
          />
        )}
      </div>
      <Dialog
        open={confirmDialogOpen}
        onClose={handleConfirmDialogClose}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">
          Atenção: Nomes diferentes
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            O nome do cliente ({contaCorrente?.cliente?.nome}) e o nome fiscal (
            {contaCorrente?.cliente?.nomeFiscal}) são diferentes. Deseja
            prosseguir com a emissão do documento?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmDialogClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmDialogConfirm}
            color="primary"
            autoFocus
          >
            Prosseguir
          </Button>
        </DialogActions>
      </Dialog>

      {/* NOVO DIALOG DE CONTINGÊNCIA */}
      <Dialog
        open={dialogContingenciaOpen}
        onClose={handleDialogContingenciaClose}
        aria-labelledby="contingencia-dialog-title"
        aria-describedby="contingencia-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          id="contingencia-dialog-title"
          sx={{
            backgroundColor: "#fff3cd",
            color: "#856404",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <ErrorIcon sx={{ color: "#ff9800" }} />
          Emissão em Modo Contingência
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            <strong>Modo Contingência Ativo</strong>
          </Alert>

          <DialogContentText sx={{ mb: 2 }}>
            O documento será emitido em <strong>modo de contingência</strong> e
            transmitido posteriormente quando o servidor E-fatura estiver
            disponível.
          </DialogContentText>

          <Alert severity="info" sx={{ mt: 2, mb: 2 }}>
            <Typography variant="body2">
              Selecione o motivo da emissão em contingência:
            </Typography>
          </Alert>

          <div className="customInputContainer">
            <select
              className="customInputSelect"
              value={motivoContingenciaSelecionado}
              onChange={(e) =>
                setMotivoContingenciaSelecionado(Number(e.target.value))
              }
            >
              {MOTIVOS_CONTINGENCIA.map((motivo) => (
                <option key={motivo.codigo} value={motivo.codigo}>
                  {motivo.label}
                </option>
              ))}
            </select>
            <label className="customInputLabelSelect">
              Motivo da Contingência *
            </label>
          </div>

          {motivoContingenciaSelecionado === 0 && (
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Descreva o motivo *"
              value={descricaoContingenciaOutro}
              onChange={(e) => setDescricaoContingenciaOutro(e.target.value)}
              sx={{ mt: 2 }}
              placeholder="Especifique o motivo da emissão em contingência..."
            />
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={handleDialogContingenciaClose}
            color="inherit"
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmarContingencia}
            color="warning"
            variant="contained"
            autoFocus
            startIcon={<ErrorIcon />}
            disabled={
              motivoContingenciaSelecionado === 0 &&
              descricaoContingenciaOutro.trim().length < 10
            }
          >
            Confirmar Emissão
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Debitos;
